export const zh = {
  nav: {
    privileges: "特权",
    memberships: "会员资格",
    faqs: "常见问题",
    guides: "指南",
    news: "新闻",
    about: "关于我们",
    contact: "联系我们",
    applyOnline: "在线申请",
    eliteVisa: "泰国精英签证",
    privilegePoints: "特权积分",
    howToApply: "如何申请？",
    bronze: "铜卡 – 5年",
    gold: "金卡 – 5年",
    platinum: "白金卡 – 10年",
    diamond: "钻石卡 – 15年",
    reserve: "尊享卡 – 20年",
    family: "家庭签证",
    compare: "对比",
    blog: "文章",
    downloads: "下载",
  },
  meta: {
    homeTitle: "Thailand Elite — 长期签证与特权 | 官方 GSSA",
    homeDescription: "泰国精英（泰国特权）官方GSSA。5至20年多次往返签证，享有VIP机场服务、礼宾服务及专属特权。立即在线申请。",
  },
  hero: {
    badge: "自2015年起授权全球销售与服务代理",
    tabs: {
      overview:    "概述",
      advantages:  "优势",
      eligibility: "资格",
      membership:  "会员",
    },
    title: "泰国精英签证",
    titleSub: "5至20年特权会员资格",
    subtitle: "长期签证与特权",
    description: "简单安全 — 批准后付款。一个月内成为泰国精英会员。",
    cta: "立即在线申请",
    secure: "安全",
    support: "全球24/7支持",
    noFees: "无隐藏费用",
    payAfter: "批准后付款",
  },
  homeFaqs: {
    badge: "常见问题",
    title: "泰国精英签证 — 常见问题",
    intro: "关于泰国精英会员、Thailand Privilege Visa、申请资格以及官方申请流程的快速解答。",
    seeAll: "查看全部 36 个问题",
  },
  homeGuides: {
    badge: "会员指南",
    title: "持 Thailand Elite 签证在泰国生活",
    intro: "在泰国安家所需的一切 — 从长期签证和会员特权，到开设银行账户、办理驾照，以及全天候会员支持。",
    browseAll: "查看全部 12 份会员指南",
    featured: {
      longStayVisa: {
        title: "长期多次入境签证",
        desc: "5至20年合法居留泰国，无限次出入境，抵达即享快速通关，无需奔波出境或担忧90天签证焦虑。",
        cta: "了解签证详情",
      },
      privileges: {
        title: "在泰生活特权",
        desc: "年度健康体检、专属酒店与生活方式优惠、高尔夫及水疗福利、政府礼宾服务 — 为长期居民日常生活量身打造的特权体系。",
        cta: "探索特权内容",
      },
    },
    memberService: {
      title: "24/7 会员服务",
      desc: "礼宾服务、移民协助、预约与翻译 — 会员联络中心为您在泰每一天提供全天候支持。",
    },
  },
  atAGlance: {
    badge: "核心数据",
    title: "泰国精英概览",
    definition:
      "泰国精英（Thailand Privilege Visa）是由 Thailand Privilege Card 运营的长期签证项目，该机构是泰国国家旅游局下属的国有机构。会员可获得 5 至 20 年的多次入境签证，以及机场 VIP 服务、礼宾服务和生活方式特权。",
    facts: [
      { label: "成立时间", value: "2003年7月",                                desc: "亚洲首个投资居留项目。" },
      { label: "会员",     value: "来自 50 个国家的 40,000+ 名会员",          desc: "由全球海外人士、退休人士和远程工作者组成的活跃社区。" },
      { label: "授权",     value: "授权 GSSA — 牌照 SA21/012",                desc: "Dreamond 是项目的完全认证全球销售与服务代理。" },
      { label: "签证期限", value: "5 至 20 年",                               desc: "外国人在泰国可获得的最长多次入境签证。" },
      { label: "价格范围", value: "650,000 – 5,000,000 泰铢",                desc: "一次性会员费 — 无每年续费。" },
      { label: "会员等级", value: "Bronze · Gold · Platinum · Diamond · Reserve", desc: "从入门级 Bronze 到仅限受邀的 20 年 Reserve。" },
    ],
  },
  overview: {
    badge: "政府所有项目",
    title: "泰国精英",
    subtitle: "泰国特权长期居留",
    description: "泰国精英是亚洲首个享有特权的长期居留签证项目。拥有来自50个国家的40,000多名会员，泰国精英是您在泰国生活与旅行的VIP通行证。",
    card1Title: "泰国精英通行证",
    card1Desc: "会员获得5年可续期多次入境签证——泰国最长的签证。",
    card2Title: "认可与便利",
    card2Desc: "让您在泰国的生活更轻松。获得政府机构协助，享受特权世界。",
    card3Title: "特权",
    card3Desc: "礼宾服务、机场快速通道、豪华轿车服务，以及酒店、水疗和高尔夫球场的专属折扣。",
  },
  advantages: {
    badge: "成为泰国VIP",
    title: "优势",
    description: "成为泰国精英会员可享受独家福利，包括5年多次入境签证、泰国银行账户、驾照、24/7礼宾服务、机场快速通道和豪华轿车服务。",
    visa: "5年多次入境签证",
    visaDesc: "使用最长签证在泰国全年或部分时间居住。",
    banking: "泰国银行账户",
    bankingDesc: "开设多币种银行账户，享受完整的网上银行服务。",
    concierge: "24/7礼宾服务",
    conciergeDesc: "全天候为您的所有需求提供个人协助。",
    airport: "机场快速通道",
    airportDesc: "在主要机场享受VIP移民处理，免排队。",
    limousine: "豪华轿车服务",
    limousineDesc: "免费豪华车机场接送。",
    lifestyle: "生活方式特权",
    lifestyleDesc: "高级酒店、水疗、高尔夫球场和餐厅的专属折扣。",
  },
  eligibility: {
    title: "资格要求",
    subtitle: "泰国精英申请条件",
    items: [
      "在泰国无签证逾期记录",
      "持有被接受国家的外国护照",
      "未被宣布为精神不健全或无行为能力",
      "在任何国家无监禁判决（过失除外）",
      "申请须经移民局批准",
      "支付所选计划的会员费用",
    ],
  },
  memberships: {
    intro: {
      title: "长期居留签证，尊享特权一应俱全",
      body1:
        "Thailand Privilege Card（国际通称 Thailand Elite）是泰国王国唯一由政府支持的长期居留计划。每一档会员均可获得多次入境的尊享入境签证，有效期覆盖整个会籍期间——Bronze 和 Gold 为 5 年，Reserve 最长可达 20 年。每次入境可在泰停留 1 年，并可在泰国境内续签，无需出境。",
      body2:
        "除签证之外，会员还可享受一套精心策划的尊贵服务，让在泰生活轻松无忧：机场移民快速通道与 VIP 迎宾、免费豪华车接送、24/7 多语种贴身管家、政府事务及行政协助、银行开户支持、年度健康体检，以及在全国高尔夫、水疗、餐饮和酒店合作伙伴处的专属生活方式特权。",
      body3:
        "对于经常出差的商务人士、退休人士、远程工作者，以及希望在泰定居的家庭而言，Thailand Elite 提供卓越的综合价值——以单一、可预期的会员资格，取代反复的签证更新、繁琐的延签手续以及众多分散的礼宾与移民服务。",
    },
    comparison: {
      title: "比较全部 5 种会员资格",
      intro: "泰国精英 5 个现行会员等级的对照概览：价格、签证期限、家庭选项和年度特权积分。",
      headers: {
        tier: "等级",
        duration: "期限",
        price: "价格",
        family: "家庭选项",
        points: "特权积分",
      },
      viewFullCta: "查看完整功能对比",
    },
    badge: "会员计划",
    title: "Thailand Privilege 会员资格",
    subtitle: "了解泰国精英会员等级",
    learnMore: "了解更多",
    perYear: "每年",
    years: "年",
    tiers: {
      bronze: { name: "铜卡", duration: "5年", price: "THB 650,000", description: "5年会员资格，包含多次入境签证和精选特权，简化您在泰国的生活。申请截止2026年12月31日。" },
      gold: { name: "金卡", duration: "5年", price: "THB 900,000", description: "5年会员资格，包含多次入境签证和高级特权，提升您的泰国体验。" },
      platinum: { name: "白金卡", duration: "10年", price: "THB 1,500,000", description: "10年会员资格，签证覆盖全部期限，享有专属特权。家庭成员2026年12月31日前每人75万泰铢。" },
      diamond: { name: "钻石卡", duration: "15年", price: "THB 2,500,000", description: "15年会员资格，签证和无与伦比的特权。家庭成员2026年12月31日前每人75万泰铢。" },
      reserve: { name: "尊享卡", duration: "20年", price: "THB 5,000,000", description: "专属邀请制20年会员——泰国精英的最高级别。" },
    },
  },
  discontinuedMemberships: {
    metaTitle: "已停止的 Thailand Elite 会籍 | 2023 年结束的历史项目",
    metaDescription: "为已停止的 Thailand Elite 历史会籍会员提供的信息。查看当前会籍方案、升级可能性，并联系团队咨询续期或延展。",
    badge: "历史会籍",
    title: "已停止的 Thailand Elite 会籍",
    subtitle: "这些旧版 Thailand Elite 项目已于 2023 年停止。如果您已经是其中某个项目的会员，根据您当前状态和到期时间，您仍可能拥有升级、延展或续期选项。",
    programsTitle: "本页涵盖的历史项目",
    programsIntro: "如果您是通过以下历史项目之一加入 Thailand Elite，本页将帮助您了解下一步最合理的选择。",
    rightsTitle: "您当前的权利与礼遇",
    rightsBody: "如果您已经是这些历史会籍之一的会员，通常您仍可继续享有与该会籍相关的服务和礼遇，具体以您的欢迎信、会员条款以及官方项目文件中的说明为准，直至会籍到期。\n\n关于您具体享有的权益，请始终以您原始会员文件及适用于该特定项目的官方条件为准。",
    upgradeTitle: "升级与续期选项",
    upgradeBody: "这些旧会籍已不再接受新申请。现有会员可能需要根据当前会籍类型和到期时间，转到现行的 Thailand Privilege 会籍方案。\n\n对于某些旧会籍，仍可能存在特定升级路径。例如，Elite Easy Access 会员在当前会籍到期前 6 个月内，仍可能有资格升级至 Elite Superiority Extension（20 年）。",
    contactTitle: "如果您已经是会员",
    contactBody: "如果您已经是 Thailand Elite 会员，并希望了解自己的续期、延展或升级选项，请联系团队或发起在线聊天。我们可以查看您的当前状态，并为您建议最合适的下一步。",
    actionsTitle: "建议的下一步",
    actionsIntro: "先查看当前会籍方案。如果您需要帮助判断自己作为现有会员可用的选项，请联系我们。",
    viewMemberships: "查看当前会籍方案",
    contactUs: "联系团队",
    note: "重要提示：可用的升级或续期路径取决于您当前的会籍、状态以及距到期的剩余时间。最终资格始终以申请时有效的官方项目规则为准。",
  },
  steps: {
    title: "3步成为会员",
    subtitle: "透明快捷。从申请到会员资格仅需4至12周。",
    step1Title: "申请",
    step1Desc: "提交您所选会员资格的泰国精英申请。",
    step2Title: "批准",
    step2Desc: "等待移民局批准（4-12周），然后完成付款。",
    step3Title: "会员",
    step3Desc: "付款到账后，您正式成为泰国精英会员。",
    ctaButton: "申请 Thailand Privilege",
  },
  cta: {
    title: "加入40,000+泰国精英会员",
    description: "加入泰国唯一的居留项目，享受特权世界和VIP服务。",
    button: "立即申请",
  },
  footer: {
    usefulLinks: "有用链接",
    contact: "联系方式",
    social: "为什么选择我们",
    followUs: "关注我们",
    ratings: "所有平台4.8/5评分",
    authorized: "作为国家机构（SA21/012）授权的全球销售与服务代理（GSSA），Dreamond为Thailand Privilege Card / Thailand Elite计划提供专业咨询、申请服务和支持。我们对卓越、透明和客户成功的承诺使我们成为行业最值得信赖的名字。",
    copyright: "版权所有 2026 Thailand Elite GSSA。保留所有权利。由Dreamond提供支持",
    gssaAttribution: "泰国精英长期签证项目授权全球销售与服务代理 (GSSA) — Dreamond，牌照号 SA21/012。",
    privacy: "隐私政策",
    terms: "使用条款",
    requestInfo: "请求更多信息",
    applyOnline: "24/7在线申请",
  },
  trust: {
    noExtra: "无额外费用",
    experience: "25+年经验",
    support: "24/7多语言支持",
    licensed: "持证服务商",
    secure: "100%安全处理",
  },

  notFound: {
    title: "页面未找到",
    subtitle: "您访问的页面不存在或已被移动。",
    backHome: "返回首页",
    home: "首页",
    homeDesc: "返回主页面",
    memberships: "会员资格",
    membershipsDesc: "探索我们的会员等级",
    faqs: "常见问题",
    faqsDesc: "查找常见问题解答",
    contact: "联系我们",
    contactDesc: "与我们的团队取得联系",
  },

  about: {
    metaTitle: "关于泰国精英GSSA – 自2015年起授权代理",
    metaDescription: "了解泰国精英GSSA，自2015年起帮助超过40,000名会员的授权全球销售与服务代理。",
    badge: "关于我们",
    title: "您值得信赖的泰国精英合作伙伴",
    subtitle: "作为自2015年起的授权GSSA代理，我们为全球申请者简化泰国精英会员流程。",
    whatIsTitle: "什么是泰国精英？",
    whatIsP1: "泰国精英的诞生源于一个独特愿景：向尊贵的外国宾客呈现泰国最优质的度假和长期居留体验。2003年7月，泰国精英成为亚洲第一个长期居留投资计划。",
    whatIsP2: "泰国精英由Thailand Privilege Card Company Limited运营，该公司是泰国国家旅游局（TAT）旗下的国有企业，TAT为其唯一股东。目前拥有来自50多个国家的40,000余名会员，泰国精英始终是亚洲领先的居留项目。",
    objectivesTitle: "泰国精英的目标",
    objectives: {
      attract: { title: "吸引尊贵宾客", desc: "泰国精英致力于吸引富裕宾客、商界人士、企业家、投资者及长期居留人士，通过向会员提供丰厚的权益、特权和服务来实现这一目标。" },
      privileges: { title: "一流专属特权", desc: "我们的移民和机场服务，以及广泛的休闲和商务权益，使泰国精英成为全球最卓越的国家居留计划。" },
      treatment: { title: "卓越礼遇", desc: "泰国各地的高尔夫球场、水疗中心、酒店、度假村、餐厅、医院和医疗机构都以世界级服务恭候我们的会员。" },
      friend: { title: "泰国的尊贵朋友", desc: "我们竭力让您在泰国王国尽享愉悦，以独具泰国热情好客特色的温暖拥抱和欢颜笑语诚挚欢迎您的到来。" },
    },
    visionTitle: "我们的愿景",
    visionText: "成为亚洲领先的、专为泰国之友打造的卓越居留计划提供商。",
    missionTitle: "我们的使命",
    missionItems: [
      "提供泰国特权入境签证（PE）",
      "提供最受欢迎的特权和服务，持续超越会员期望",
      "提升泰国奢华旅游业",
      "支持公私两个领域，促进泰国经济增长"
    ],
    coreValuesTitle: "核心价值观",
    coreValuesText: "诚信、透明、承诺与响应。我们的目标是为尊贵的泰国精英会员提供优质、专业的服务——从申请到享受会员特权，全程如丝般顺畅。",
    storyTitle: "我们是谁",
    storyP1: "自2015年以来，我们一直是Thailand Privilege Card Company Limited正式授权的全球销售与服务代理（GSSA）——该公司是运营泰国精英项目的政府所有实体。",
    storyP2: "我们的使命是为寻求在泰国长期居留的个人提供流畅、透明和安全的申请体验。我们在每一步都为您提供指导，从初次咨询到会员激活。",
    storyP3: "凭借服务50多个国家客户的多语言团队，我们将深厚的本地专业知识与全球视角相结合，提供世界级服务。",
    valuesTitle: "我们的价值观",
    valuesSubtitle: "指导我们一切工作的原则。",
    values: {
      trust: { title: "信任与透明", desc: "无隐藏费用，无意外。我们在每个阶段都完全透明运营。" },
      excellence: { title: "卓越", desc: "我们在每次客户互动中追求最高标准的服务。" },
      service: { title: "个性化服务", desc: "从申请到会员及之后的全程专属支持。" },
      global: { title: "全球覆盖", desc: "为50多个国家的客户提供多语言支持。" },
      government: { title: "政府背书", desc: "官方授权确保合法性和可靠性。" },
      exclusive: { title: "专属通道", desc: "所有会员享受优先处理和VIP待遇。" },
    },
    stats: {
      members: { value: "40,000+", label: "全球会员" },
      countries: { value: "50+", label: "服务国家" },
      yearsExp: { value: "10+", label: "年经验" },
      satisfaction: { value: "4.8/5", label: "客户满意度" },
    },
    whoTitle: "合作伙伴与认证",
    whoDesc: "泰国精英会员计划由Thailand Privilege Card Company Limited运营，该公司由泰国旅游部和泰国国家旅游局（TAT）全资拥有。推广和申请支持由Dreamond提供，Dreamond是持牌授权的GSSA（注册号SA21/012）。",
    tpcLearnMore: "→ 了解更多关于泰国特权卡计划",
    tpcGuideLink: "→ 泰国特权卡完整指南",
    tpcCardLink: "→ 泰国特权卡 — 会员、权益与申请方式",
    dreamondTitle: "Dreamond — 持牌GSSA代理",
    dreamondDesc: "作为国家机构（SA21/012）授权的全球销售与服务代理（GSSA），Dreamond为Thailand Privilege Card / Thailand Elite计划提供专业咨询、申请服务和支持。我们对卓越、透明和客户成功的承诺使我们成为行业最值得信赖的名字。",
    dreamondFeatures: [
      "无额外费用——仅在批准后向政府机构付款",
      "拥有25年以上综合经验的专业团队",
      "多语言24/7世界级支持",
      "完全持牌、受监管的服务提供商",
      "100%安全保密处理"
    ],
    officialSources: {
      title: "政府机构",
      intro: "泰国精英是泰国的官方长期签证项目。有关旅游政策监管和移民法规，请参阅下列泰国政府机构。",
      tat: "泰国国家旅游局 (TAT)",
      immigration: "泰国皇家移民局",
    },
  },

  contact: {
    metaTitle: "联系泰国精英GSSA",
    metaDescription: "联系我们的团队，获取泰国精英会员咨询和申请支持。24/7多语言服务。",
    title: "联系我们",
    subtitle: "如您对泰国精英会员有任何疑问或希望获取相关资料，请随时联系我们。",
    infoTitle: "联系方式",
    infoSubtitle: "如您对泰国精英会员有任何疑问或希望获取相关资料，请随时联系我们。",
    disclaimer: "请仅就泰国精英相关问题联系我们。",
    disclaimerSub: "我们不是大使馆，也不办理旅游签证。",
    memberNote: "如果您已经是泰国精英会员，",
    memberNoteDetail: "请联系会员服务中心（参阅欢迎邮件）或您的代理。",
    email: "电子邮件",
    address: "总部地址",
    addressValue: "泰国曼谷——仅限预约。",
    hours: "工作时间",
    hoursValue: "周一至周五 9:00-18:00（泰国标准时间）",
    usefulLinks: "有用链接",
    linkFaqs: "常见问题解答",
    linkApply: "在线申请门户",
    linkMemberships: "会员计划",
    linkHowToApply: "申请流程",
    worldwide: "我们在全球各地设有代理。",
    formTitle: "给我们发消息",
    formSubtitle: "填写表格，我们的团队将尽快回复您。",
    firstName: "名字",
    lastName: "姓氏",
    emailLabel: "电子邮件",
    phoneLabel: "电话",
    subject: "主题",
    selectSubject: "选择主题...",
    subjectMembership: "会员信息",
    subjectPricing: "价格与费用",
    subjectApplication: "申请流程",
    subjectRenewal: "续期与延期",
    subjectOther: "其他",
    message: "留言",
    messagePlaceholder: "请告诉我们您的需求...",
    send: "发送消息",
      sendAnother: "发送另一条消息",
    successTitle: "消息已发送",
    successMsg: "您的消息已发送。请查收确认邮件，我们将尽快回复您。",
    errorTitle: "信息不完整",
    errorServer: "发生错误，请重试。",
    errorRequired: "请填写您的姓名、电子邮件和消息。",
  },

  faqs: {
    metaTitle: "泰国精英常见问题",
    metaDescription: "查找关于泰国精英会员、签证、费用和申请流程的常见问题解答。",
    title: "常见问题",
    subtitle: "关于泰国精英会员您需要了解的一切。",
    searchPlaceholder: "搜索常见问题...",
    resultsFound: "个结果",
    noResults: "未找到结果，请尝试其他搜索词。",
    categories: {
      application: "申请流程",
      visa: "签证与入境",
      payment: "支付与费用",
      membership: "会员与工作",
      services: "会员服务",
      reporting: "报告与合规",
    },
    items: {
      appProcess: { q: "申请流程需要多长时间？", a: "整个流程需要1至3个月。我们团队负责提交并在每一步都通知您。仅在移民局批准后才需付款。" },
      requiredDocs: { q: "需要哪些文件？", a: "护照首页复印件（至少1年有效期）、彩色证件照（高分辨率）、所选会员等级的申请表，以及家庭申请时的亲属关系证明。可通过在线门户或电子邮件提交。" },
      applyRemotely: { q: "可以远程申请吗？", a: "可以，整个流程可以通过我们的在线申请门户或电子邮件完成。无需身在泰国即可申请。" },
      applyFamily: { q: "可以和家人一起申请吗？", a: "可以，直系亲属（父母、子女、配偶）可加入白金10年和钻石15年会员。目前有家庭促销折扣。" },
      eligibility: { q: "哪些国籍可以申请？", a: "所有国家的公民（除朝鲜外）均可申请泰国精英会员。" },
      edVisa: { q: "有教育签证(ED)历史可以申请吗？", a: "可以，但申请可能更容易被拒。提供学校执照、注册证明和成绩单可加强申请。" },
      overstay: { q: "签证过期可以申请吗？", a: "不可以，您必须先离境。申请不构成签证延期。" },
      whatIsVisa: { q: "什么是泰国精英签证？", a: "泰国精英签证是'特权入境签证'(PE)——5年可续多次入境签证，每次入境可延长1年居留。" },
      visaDuration: { q: "不出境可以在泰国住超过1年吗？", a: "入境章默认允许1年居留。如不出行，须在入境章到期前申请居留延期。泰国精英团队可协助办理。" },
      passportValidity: { q: "护照不足5年有效期怎么办？", a: "签证将按护照到期日签发。续签护照后，剩余签证有效期将转移到新护照。" },
      visaLessThan5: { q: "为什么签证有效期不足5年？", a: "因为您的护照有效期不足5年。联系会员服务在获取新护照后续签签证。" },
      stayExtension: { q: "年度居留延期如何操作？", a: "签证虽5年有效，但每次居留限1年。如不出境，需在入境章到期前到移民局申请延期。团队提供协助信函。" },
      ninetyDay: { q: "什么是90天报到要求？", a: "连续停留超过90天的外国人须每90天报告地址。出境后重新计算。可在线、邮寄或到移民局办理。曼谷、芭提雅、普吉和清迈提供免费代办。" },
      visaAffix: { q: "在哪里办理签证贴签？", a: "曼谷Chaeng Wattana移民局（工作日）；素万那普 Suvarnabhumi 机场国际航班抵达时（24小时，需提前5个工作日预约）；普吉机场或清迈机场抵达时。" },
      howToPay: { q: "如何付款？", a: "批准后，您将收到Thailand Privilege Card Co., Ltd.（国有公司）的正式批准函和发票。您有30天时间付款。" },
      isSafe: { q: "付款安全吗？", a: "安全。仅在移民局批准后才要求付款。付款直接支付给国有公司Thailand Privilege Card Co., Ltd.。" },
      paymentMethods: { q: "有哪些支付方式？", a: "银行转账（本地和国际SWIFT）、信用卡（Visa、万事达、银联）、支付宝、PromptPay（泰国二维码）和Krungthai银行网点现金汇款。" },
      workPermit: { q: "精英签证可以在泰国工作吗？", a: "PE签证属于旅游签证类别，不允许申请工作许可。如收入来自海外，可持有精英签证。可以是泰国公司股东或董事但不能积极就业。" },
      touristVisa: { q: "持旅游签证可以申请吗？", a: "可以，可以用旅游签证、落地签或免签申请。如果当前签证未过期，可安排在Chaeng Wattana移民局贴签。" },
      nonBVisa: { q: "持Non-B签证和工作许可可以申请吗？", a: "可以，但Non-B签证须在精英签证激活前注销，因为泰国法律只允许一个有效签证。" },
      nonOVisa: { q: "持Non-O（婚姻）或Non-OA（退休）签证可以申请吗？", a: "可以，但需在精英签证贴签前注销非移民签证。我们团队将提供详细步骤和所需文件。" },
      cancel: { q: "可以取消会员吗？", a: "在特定条件下可取消，根据剩余时间可获部分退款。请联系我们了解具体政策。" },
      whatIsTPC: { q: "什么是Thailand Privilege Card？", a: "Thailand Privilege Card Co., Ltd.是运营泰国精英会员计划的国有公司。'泰国精英'是使用超过20年的通用名称。两者指同一计划。" },
      bankAccount: { q: "会员可以开设银行账户吗？", a: "可以。会员可开设泰铢储蓄账户和多币种账户。与曼谷银行和开泰银行有合作，可加速开户。" },
      howOpenBank: { q: "如何开设银行账户？", a: "持有精英签证和会员卡后，可携带护照、签证、会员卡、泰国手机号和地址信息到曼谷银行或开泰银行任何网点办理。无签证和卡须提前5个工作日通过电子邮件预约。" },
      drivingLicense: { q: "如何申请泰国驾照？", a: "通过Elite Personal Liaison (EPL)服务在陆路运输部（曼谷Chatuchak）办理。如有本国驾照，一天内完成。所需文件：有效签证、护照（6个月以上）、使馆地址证明和泰国体检证明。" },
      transferService: { q: "如何预约机场接送？", a: "联系会员联络中心，提供日期、航班信息和地址。至少提前5小时预约。服务仅在素万那普 Suvarnabhumi 机场国际航班可用。" },
      epaService: { q: "什么是精英个人助理(EPA)服务？", a: "EPA是在机场协助您办理快速通道移民和行李等事务的泰国精英工作人员。穿金色制服并举有您姓名的牌子。在素万那普、普吉和清迈机场6:00-24:00提供服务。至少提前5小时预约。" },
      eplService: { q: "什么是Elite Personal Liaison (EPL)服务？", a: "EPL协助在曼谷办理政府服务：居留延期、签证贴签、签证转移到新护照、驾照申请和银行开户。首次免费，之后每次THB 2,000（最多3小时）。提前5至7个工作日预约。" },
      ninetyDayReport: { q: "如何提交90天报到？", a: "每周二16:30前将护照和TM47表格送至曼谷Sathorn路总部。工作人员周三提交至移民局，护照可在工作日取回。到期前15天至到期后7天内提交。芭提雅、普吉和清迈办事处也提供服务。" },
      stayExtensionReport: { q: "居留延期何时办理？", a: "PE签证持有者每年须办理一次居留延期。连续停留超过90天仍需90天报到。可提前30天办理。逾期罚款每天THB 500，最高THB 20,000。所需文件：含签证的护照、TM.6、TM.7、2寸照片和精英官方信函。" },
      tm30: { q: "什么是TM30？", a: "TM30是房东或房产所有者必须在外国人到达24小时内向移民局报告其住宿情况的表格。此法律自1979年起实施，现已严格执行。" },
      tm30Who: { q: "谁负责提交TM30？", a: "责任在于房东：房产所有者、酒店或服务式公寓。未报告的罚款为每人THB 1,600。" },
      tm30Purpose: { q: "TM30规定的目的是什么？", a: "政府通过TM30随时掌握每位外国人的住宿地点。每位房东须在24小时内报告。" },
      tm30HowTo: { q: "如何报告TM30？", a: "房东准备房产证和租赁合同复印件，以及您的护照、签证页和出境卡复印件。可到最近的移民局或在线报告。" },
      residenceCert: { q: "如何获取居住证明？", a: "可向您在泰国的母国大使馆或移民局申请。向移民局申请前须完成最近一次入境后的90天报到。建议尽可能向大使馆申请。" },
      childrenVisa: { q: "儿童需要有效泰国签证吗？", a: "是的，任何年龄的外国人都需要有效签证。上学的孩子可从学校获得教育签证。您可以从白金或钻石等级添加儿童会员。14岁以下儿童逾期停留只会在护照上盖章，如与持有效签证的父母同行则无其他后果。" },
    },
  },

  news: {
    metaTitle: "泰国精英新闻与动态",
    metaDescription: "了解泰国精英会员计划的最新消息、签证更新和专属会员活动。",
    title: "新闻与动态",
    subtitle: "关注泰国精英项目的最新资讯。",
    readMore: "阅读更多",
    cmsNote: "更多文章即将推出。博客CMS集成进行中。",
    articles: {
      article1: { date: "2026年2月10日", title: "泰国精英突破40,000会员里程碑", excerpt: "泰国精英项目正式突破40,000名活跃会员，标志着亚洲首个投资居留项目的重要里程碑。" },
      article2: { date: "2026年1月28日", title: "2026年新增特权合作伙伴", excerpt: "泰国精英与泰国15家新豪华酒店、高尔夫球场和健康中心建立合作关系。" },
      article3: { date: "2026年1月15日", title: "申请流程加速更新", excerpt: "Thailand Privilege Card Company简化了申请流程，将平均审批时间缩短至4-6周。" },
      article4: { date: "2025年12月20日", title: "泰国被评为数字游民首选目的地", excerpt: "泰国继续位居全球远程工作者和数字游民的首选目的地之列。" },
      article5: { date: "2025年12月5日", title: "专属会员活动：曼谷晚宴", excerpt: "泰国精英在曼谷为会员举办了专属晚宴，提供交流、美食和娱乐。" },
      article6: { date: "2025年11月18日", title: "会员医疗福利扩展", excerpt: "与曼谷顶级医院的新合作伙伴关系为会员提供优先获得世界级医疗服务的机会。" },
      article7: {
        date: "2026年2月14日",
        title: "泰国精英签证税务指南 — 会员须知",
        excerpt: "作为泰国精英签证持有人，了解您的税务义务至关重要。本文介绍泰国税务居民规则、180天规则、应税收入、税收协定优惠，以及泰国精英签证如何简化在泰的长期财务规划。",
        fullContent: "作为泰国精英签证持有人，了解您在泰国的税务立场对长期规划至关重要。以下是泰国精英签证税务注意事项的要点。\n\n**泰国税务居民 — 180天规则**\n根据泰国税法，若您在一个日历年内在泰国停留180天或以上，即成为税务居民。税务居民须就来源于泰国境内的收入缴纳个人所得税。\n\n**境外来源收入**\n历史上，境外来源收入仅在与取得收入同年汇入泰国时才须纳税。自2024年1月1日起，泰国税务局更新了对境外来源收入的解释。境外收入只有在汇入泰国时，才可能在泰国产生纳税义务。\n\n这项规则仅适用于泰国税务居民，也就是在一个日历年内在泰国停留180天或以上的人士。这并不意味着所有境外收入都会自动被征税。实际适用范围通常是，由泰国税务居民汇入泰国，且在其成为泰国税务居民之后产生，或自2024年1月1日起产生的境外来源收入。双重征税协定也可能根据收入类型和相关国家减少或免除泰国税负。若您每年在泰国停留不足180天，您的境外收入通常无需在泰国纳税。\n\n**泰国精英签证与税务规划**\n泰国精英签证（特权入境签证）被划定为旅游签证类别，不授予工作许可。许多泰国精英会员在居住泰国的同时，在境外经营业务和管理投资。了解旅游活动与应税经济活动之间的区别是合规的关键。\n\n**双重征税协定（DTA）**\n泰国已与60多个国家签署双重征税协定，这些协定可减少或消除某些类型收入的双重征税。请咨询合格的泰国税务顾问，了解您所在国与泰国的税收协定如何适用于您的具体情况。\n\n**泰国精英会员的重要建议**\n1. 仔细记录在泰国的天数——180天是判定税务居民身份的关键门槛。\n2. 保存所有收入来源和汇款记录。\n3. 做出财务决策前请咨询持牌泰国税务顾问。\n4. 考虑收入汇款的时间安排和结构。\n5. 在适用情况下充分利用您所在国与泰国的税收协定。\n\n**免责声明**：本文仅供参考，不构成税务建议。税法频繁变动，请就您的具体情况咨询专业税务人员。",
      },
    },
  },

  privileges: {
    metaTitle: "泰国精英特权 – 专属会员权益与服务",
    metaDescription: "了解泰国精英会员的全部特权：VIP机场快速通道、豪华轿车、水疗、高尔夫、政府协助、医疗保健和特权积分。",
    badge: "泰国特权",
    title: "泰国精英特权",
    subtitle: "成为泰国精英会员，您将享受一系列专属泰国特权——从VIP机场服务和奢华生活方式福利，到政府协助和高端医疗保健。",
    intro1: "作为泰国精英会员，您将享受全方位的泰国特权，让您在泰国的生活更加轻松愉快。除了拥有无限次出入境的长期特权入境签证外，您还可以享受机场协助、优先移民办理、24/7礼宾服务、豪华轿车接送、水疗、高尔夫等众多服务——具体权益因会员等级而异。",
    intro2: "自2023年10月1日起全新推出的泰国精英项目中，每个会员等级每年都会获得一定数量的特权积分，可用于兑换住宿、旅行、休闲、健康和财富五大类别的服务。这种积分制度让您自由选择最适合自己的泰国特权。",
    highlights: {
      visa: { title: "长期多次入境签证", desc: "泰国最长签证——5年可续特权入境签证（PE），每次入境可延长1年居留。" },
      recognition: { title: "VIP礼遇", desc: "从抵达泰国的那一刻起，在各大机场由精英个人助理为您提供一流礼遇。" },
      facilitation: { title: "政府协助", desc: "作为国有企业，泰国精英为政府机构提供个性化支持——签证、移民、银行开户、驾照办理。" },
      lifestyle: { title: "专属生活方式福利", desc: "在全泰顶级酒店、水疗中心、高尔夫球场、餐厅和购物中心享受专属折扣和VIP通道。" },
    },
    pointsCta: {
      title: "特权积分 — 自由选择",
      desc: "每个泰国精英会员资格均附带年度特权积分，可兑换专属服务，包括私人接送、酒店住宿、健康疗养、购物和娱乐。",
      button: "了解特权积分",
    },
    relatedGuides: {
      title: "泰国精英会员实用指南",
      intro: "最常用会员服务的分步指南：开设银行账户、驾照、税务、签证延期和 TM30 申报。",
    },
    categories: {
      arrival: {
        title: "抵达与离境服务",
        overview: "每次乘坐国际航班抵达素万那普 Suvarnabhumi、普吉或清迈机场时，专属精英个人助理将在登机口迎接您，陪同您前往专属到达贵宾室，并协助您快速完成入境手续。离境时，快速通道移民办理和贵宾室通道确保您出行顺畅无忧。",
        items: {
          fastTrack: { title: "VIP机场快速通道", desc: "在素万那普 Suvarnabhumi、普吉和清迈机场享受专属精英个人助理服务，免排队办理移民手续。提供时间：06:00至24:00，需提前至少5小时预约。" },
          limousine: { title: "豪华轿车接送", desc: "在机场与您的住所或酒店之间享受免费豪华私家车接送服务。覆盖曼谷（两个机场）、清迈、普吉和苏梅岛。根据会员等级，每年最多可享24次短程接送。" },
          lounge: { title: "专属机场贵宾室", desc: "在专属泰国特权贵宾室放松候机，享用免费餐饮和Wi-Fi。同时可使用Changwattana贵宾室办理移民手续。" },
        },
      },
      lifestyle: {
        title: "生活方式与休闲",
        overview: "作为泰国精英卡会员，您可在泰国最优质的场所享受专属折扣和VIP体验。从世界级高尔夫球场和精彩水疗体验，到精致餐饮和奢华购物——您的泰国精英特权卡为您开启王国各处的尊享之门。",
        items: {
          spa: { title: "精彩水疗体验", desc: "在泰国顶级水疗中心、健康度假村和保健中心享受专属通道和折扣。泰国以世界级水疗体验著称，精英会员可享优先预约和特别优惠。" },
          golf: { title: "高尔夫天堂", desc: "泰国是高尔夫爱好者的天堂，从清莱到苏梅岛均有世界级球场。在全泰高端高尔夫球场享受免费轮次、优惠果岭费和温馨球童服务。" },
          dining: { title: "精致餐饮与娱乐", desc: "在顶级餐厅享受特别优惠和优先预订，欣赏VIP电影、世界级演出，参与专为泰国精英会员保留的独家餐饮体验。" },
          shopping: { title: "VIP购物体验", desc: "在主要购物中心享受专属折扣、私人购物助理、高端商场贵宾室通道，以及泰国各地奢侈品零售合作伙伴的特别优惠。" },
        },
      },
      government: {
        title: "政府协助与行政服务",
        overview: "作为国有企业，泰国精英为会员提供联系其他泰国政府机构的个性化支持服务，协助办理与居留相关的重要文件——包括签证延期、90天报到、银行开户和驾照申请。",
        items: {
          immigration: { title: "90天报到协助", desc: "泰国精英工作人员代为处理强制性的90天移民报到。曼谷、芭提雅、普吉和清迈提供上门代办服务。每周二16:30前将护照交至曼谷Sathorn路总部即可，省心省力。" },
          drivingLicense: { title: "泰国驾驶执照", desc: "Elite Personal Liaison (EPL)服务协助您在陆路运输部办理驾照。持有本国驾照时，包括所有文件准备在内，一天即可完成全部手续。" },
          bankAccount: { title: "银行开户", desc: "在曼谷银行和开泰银行快速开设泰铢储蓄账户和多币种账户。泰国精英的合作关系确保凭精英签证和会员卡顺利开户。" },
          workPermit: { title: "Elite Personal Liaison (EPL)", desc: "EPL协助在曼谷办理政府服务，包括居留延期、在Chaeng Wattana移民局贴签、护照转签、驾照办理和银行开户。首次服务免费。" },
        },
      },
      health: {
        title: "高端医疗与健康",
        overview: "泰国的医院和医疗机构以其卓越品质享誉全球。接受国际培训的医护人员、先进的医疗设施、酒店式住院环境和多语言支持，使泰国成为全球医疗旅游的领导者。作为泰国精英会员，您可优先享受这些世界级服务。",
        items: {
          healthCheck: { title: "年度健康体检", desc: "白金及以上等级会员可在领先的国际标准医院免费享受年度健康体检。充分利用泰国卓越的医疗资源。" },
          insurance: { title: "保险与理财咨询", desc: "专为泰国外籍人士和长期居民量身定制的健康和旅行保险方案，以及财富和投资顾问服务。" },
          dental: { title: "牙科与健康", desc: "在高端诊所享受优惠牙科服务、顶级酒店连锁健身会员，以及泰国各地综合水疗与健康套餐。" },
        },
      },
    },
  },

  howToApply: {
    metaTitle: "如何申请泰国精英 – 逐步指南",
    metaDescription: "了解如何申请泰国精英会员。简单6步流程，仅在批准后付款。立即开始您的申请。",
    title: "如何成为泰国精英会员？",
    subtitle: "从申请到会员激活的简单透明流程。仅在批准后付款。",
    steps: {
      step1: {
        title: "步骤1. 选择适合您生活方式的会员等级",
        desc: "泰国精英会员资格旨在满足会员的不同需求和生活方式。",
        details: "类型：个人或家庭。期限：5年、10年、15年或20年。浏览不同的泰国会员等级，如需帮助请联系我们。",
      },
      step2: {
        title: "步骤2. 提交申请",
        desc: "在线开始申请或联系我们获取最新申请表。",
        details: "申请流程100%在线完成，通过我们的申请门户或电子邮件。如需帮助选择和填写申请，请随时联系我们。我们可以安排电话、视频通话或通过WhatsApp或邮件沟通。",
      },
      step3: {
        title: "步骤3. 等待移民局审批（4至8周）",
        desc: "您的申请和文件将提交至移民局进行背景调查。",
        details: "通常此流程约需8周，但某些国籍可能需要更长时间。批准后，您将收到包含批准函的电子邮件。",
      },
      step4: {
        title: "步骤4. 付款",
        desc: "获批后，您将收到付款邀请。",
        details: "提供多种付款方式：银行转账、信用卡。付款后，请向我们发送付款证明。批准前无需付款。",
      },
      step5: {
        title: "步骤5. 激活会员资格",
        desc: "付款完成后，您的会员资格将在7个工作日内激活。",
        details: "会员资格激活后，您可以开始使用会员包含的服务，包括礼宾服务、特权积分和合作伙伴折扣。",
      },
      step6: {
        title: "步骤6. 粘贴泰国精英签证",
        desc: "成为泰国精英会员并收到会员ID后，您可以提前至少5天预约粘贴签证。",
        details: "如果您从国外飞往曼谷素万那普 Suvarnabhumi 机场、普吉国际机场或清迈国际机场，可在抵达时获取签证。如果您已在泰国境内，可在曼谷 Chaeng Wattana 移民局办理签证粘贴。",
      },
    },
    docsTitle: "所需文件",
    docsSubtitle: "准备这些文件以确保申请流程顺利进行。",
    docs: {
      passport: { title: "护照复印件", desc: "有效护照的彩色扫描件。" },
      photo: { title: "照片（护照格式）", desc: "近期白底护照尺寸照片。" },
      form: { title: "申请表", desc: "已填写并签名的所选会员等级申请表（我们协助您填写）。" },
      proof: { title: "亲属关系证明", desc: "结婚证、出生证明 — 仅家庭申请需要。" },
    },
    startButton: "开始申请",
    helpNote: "有任何问题？立即联系我们",
  },

  apply: {
    metaTitle: "在线申请泰国精英会员",
    metaDescription: "在线申请泰国精英会员。安全申请流程，仅在批准后付款。立即开始。",
    title: "在线申请",
    subtitle: "开始您的泰国精英会员申请。简单、安全，仅在批准后付款。",
    guarantees: {
      secure: "100%安全加密",
      fast: "24小时内回复",
      approved: "仅在批准后付款",
    },
    portalTitle: "泰国精英申请门户",
    portalDesc: "注册门户并安全提交所有文件以申请泰国精英计划。跟踪您的申请进度并直接与分配的代理沟通。",
    portalIntro: "创建账户或登录以提交并跟踪您的申请。",
    disclaimer: "提交即表示您同意我们的使用条款和隐私政策。批准前无需付款。所有付款均直接支付给Thailand Privilege Card Co., Ltd.，以其官方发票为准。",
    openDirectText: "无法显示上方的申请门户？",
    openDirectCta: "在新标签页中直接打开门户",
    tabLogin: "登录",
    tabRegister: "注册",
  },

  privacy: {
    metaTitle: "隐私政策 – 泰国精英GSSA",
    metaDescription: "阅读我们的隐私政策，了解泰国精英GSSA如何收集、使用和保护您的个人信息。",
    title: "隐私政策",
    lastUpdated: "最后更新：2026年2月",
    sections: {
      collection: { title: "我们收集的信息", content: "我们收集您在申请会员、联系我们或使用服务时自愿提供的个人信息，包括姓名、电子邮件、电话、护照信息、国籍等。" },
      usage: { title: "信息使用方式", content: "我们使用您的个人信息来处理会员申请、与您沟通申请状态、提供客户支持和改进服务。" },
      sharing: { title: "信息共享", content: "我们将必要信息与Thailand Privilege Card Company Limited共享以处理您的申请。我们不会出售或出租您的个人信息。" },
      security: { title: "数据安全", content: "我们采取适当的技术和组织措施保护您的个人信息。所有数据传输均通过SSL/TLS加密。" },
      cookies: { title: "Cookies", content: "我们的网站使用cookies来增强浏览体验、分析网站流量和个性化内容。您可以通过浏览器设置管理cookie偏好。" },
      rights: { title: "您的权利", content: "您有权访问、更正、更新或删除您的个人信息。您也可以反对或限制我们对您数据的处理。" },
      contact: { title: "联系我们", content: "如果您对本隐私政策有任何疑问，请通过info@thailand-elite.com或我们的联系页面与我们联系。" },
    },
  },

  membershipDetail: {
    backToMemberships: "返回会员资格",
    privilegesTitle: "包含特权",
    conditionsTitle: "会员条件",
    familyOffer: "家庭折扣可用",
    faqTitle: "常见问题",
    disclaimer: "泰国精英会员资格和申请人资格须经移民局批准。",
    validity: "有效期",
    membershipFee: "会员费",
    privilegePoints: "积分/年",
    compareFeature: "项目",
    bronze: {
      metaTitle: "泰国精英铜卡 – 5年签证 | THB 650,000", metaDescription: "泰国精英铜卡会员：5年多次入境签证，机场快速通道，礼宾服务。",
      badge: "5年会员", title: "铜卡会员", tagline: "5年舒适便捷之选",
      intro: "铜卡是您进入泰国五年专属体验的起点，兼顾实惠与品质。一次性费用THB 650,000，享受五年会员权益及丰富特权。注意：铜卡新申请截止2026年12月31日。",
      points: "", cta: "申请铜卡", familyDiscount: "",
      privileges: ["快速通道移民：无限次（素万那普、清迈、普吉）","Changwattana贵宾室：无限次","银行开户协助","会员联络中心24/7","90天报到服务（曼谷）","Elite Personal Liaison服务：1次","精英个人助理服务：无限次","住宿、旅行、休闲类折扣","5年可续多次入境签证","每次入境可延长1年"],
      privilegeGroups: [
        { title: "签证权益", items: [
          "5年可续多次入境签证",
          "每次入境可延长1年居留期",
          "90天报到服务（曼谷总部）"
        ] },
        { title: "机场权益", items: [
          "无限次快速通道移民（素万那普、清迈、普吉）",
          "无限次 Chaeng Wattana 贵宾室使用"
        ] },
        { title: "生活方式与行政权益", items: [
          "银行开户协助",
          "会员联络中心（MCC）24/7",
          "Elite Personal Liaison（EPL）：每份会员1次",
          "住宿、旅行及休闲类折扣"
        ] }
      ],
      conditions: [{ label: "升级", value: "是" },{ label: "可续期", value: "是" },{ label: "可转让", value: "不可转让/不可退款" }],
      faqs: [
        { q: "泰国精英铜卡会员费用是多少？", a: "铜卡会员一次性费用为 THB 650,000。新申请截止2026年12月31日。" },
        { q: "铜卡会员有效期多长？", a: "铜卡会员有效期为5年，含可续多次入境签证，每次入境可延长1年居留期。" },
        { q: "铜卡会员包含特权积分吗？", a: "不包含。铜卡是入门等级，不含年度特权积分。金卡及更高等级包含特权积分。" },
        { q: "铜卡会员可以在泰国停留满一年吗？", a: "可以。会员每次入境获得1年居留章，若在到期前未离境，可在移民局办理延期。" },
        { q: "铜卡会员可以添加家庭成员吗？", a: "不可以。铜卡为个人会员。家庭会员选项可在白金卡、钻石卡和尊享卡中获得。" },
        { q: "持铜卡会员可以在泰国工作吗？", a: "不可以。泰国精英／Thailand Privilege 不能替代工作许可。需要工作的会员必须取得相应的工作授权。" },
        { q: "持铜卡会员可以开设泰国银行账户吗？", a: "可以。银行开户协助是会员可享的核心支持服务之一。" },
        { q: "铜卡会员可以退款吗？", a: "不可以。会员资格不可转让、不可退款。" },
        { q: "我之后可以从铜卡升级吗？", a: "可以。铜卡会员可升级至金卡、白金卡、钻石卡或尊享卡等更高等级。" }
      ],
      comparison: {
        title: "铜卡 vs 金卡：哪种5年会员适合您？",
        intro: "铜卡是最易获取的5年泰国精英会员，费用最低且不含年度特权积分。金卡适合希望获得更完整生活方式体验的会员，每年20积分并附加高端服务。",
        colA: "铜卡",
        colB: "金卡",
        highlight: 0,
        rows: [
          { feature: "有效期", a: "5年", b: "5年" },
          { feature: "会员费", a: "THB 650,000", b: "THB 900,000" },
          { feature: "每年特权积分", a: "0", b: "20" },
          { feature: "适合人群", a: "以签证为主的申请人", b: "签证＋生活方式特权" }
        ]
      }
    },
    gold: {
      metaTitle: "泰国精英金卡 – 5年签证 | THB 900,000", metaDescription: "金卡：5年签证，每年20积分，VIP机场服务。",
      badge: "5年高级会员", title: "金卡会员", tagline: "为品味人士打造的5年会员",
      intro: "金卡开启泰国五年丰富旅程，兼顾实惠与奢华。一次性费用THB 900,000，每年获得20特权积分。",
      points: "20", cta: "申请金卡", familyDiscount: "",
      privileges: ["5年可续多次入境签证","每次入境可延长1年","到达和离境VIP接待","加速移民和护照检查","专属贵宾室","每年20积分","移民服务和90天报到","驾照办理协助","银行开户协助","商务网络","多语言联络中心24/7"],
      privilegeGroups: [
        { title: "签证权益", items: [
          "5年可续多次入境签证",
          "每次入境可延长1年居留期",
          "移民服务及90天报到"
        ] },
        { title: "机场权益", items: [
          "到达和离境VIP接待与陪同",
          "加速移民及护照检查",
          "专属到达和离境贵宾室"
        ] },
        { title: "生活方式与行政权益", items: [
          "每年20特权积分可兑换",
          "驾照办理协助",
          "银行开户协助",
          "商务网络支持",
          "会员联络中心：英语24/7（韩语、中文、日语）"
        ] }
      ],
      conditions: [{ label: "升级", value: "是" },{ label: "可续期", value: "是" },{ label: "可转让", value: "不可转让/不可退款" }],
      faqs: [
        { q: "泰国精英金卡会员费用是多少？", a: "金卡会员一次性费用为 THB 900,000。" },
        { q: "金卡会员有效期多长？", a: "金卡会员有效期为5年。" },
        { q: "金卡会员包含多少特权积分？", a: "金卡会员每年获得20特权积分。" },
        { q: "金卡会员可以在泰国停留满一年吗？", a: "可以。会员每次入境获得1年居留章，若在到期前未离境，可在移民局办理延期。" },
        { q: "金卡会员可以添加家庭成员吗？", a: "不可以。金卡为个人会员。家庭会员选项可在白金卡、钻石卡和尊享卡中获得。" },
        { q: "持金卡会员可以在泰国工作吗？", a: "不可以。泰国精英／Thailand Privilege 不能替代工作许可。需要工作的会员必须取得相应的工作授权。" },
        { q: "持金卡会员可以开设泰国银行账户吗？", a: "可以。银行开户协助是会员可享的核心支持服务之一。" },
        { q: "金卡会员可以退款吗？", a: "不可以。会员资格不可转让、不可退款。" },
        { q: "我之后可以从金卡升级吗？", a: "可以。金卡会员可升级至白金卡、钻石卡或尊享卡等更高等级。" }
      ],
      comparison: {
        title: "金卡 vs 铜卡：5年会员该如何选择？",
        intro: "铜卡是入门级5年泰国精英会员，费用较低且不含年度特权积分。金卡更适合希望获得更完整生活方式体验的会员，每年20积分并附加高端服务。",
        colA: "铜卡",
        colB: "金卡",
        highlight: 1,
        rows: [
          { feature: "有效期", a: "5年", b: "5年" },
          { feature: "会员费", a: "THB 650,000", b: "THB 900,000" },
          { feature: "每年特权积分", a: "0", b: "20" },
          { feature: "适合人群", a: "以签证为主的申请人", b: "签证＋生活方式特权" }
        ]
      }
    },
    platinum: {
      metaTitle: "泰国精英白金卡 – 10年签证 | THB 1,500,000", metaDescription: "白金卡：10年签证，每年35积分，家庭折扣。",
      badge: "10年精英会员", title: "白金卡会员", tagline: "十年卓越体验",
      intro: "白金精英会员专为追求极致泰国生活体验的人士设计，10年有效期，每年35积分，一次性费用THB 1,500,000。",
      points: "35", cta: "申请白金卡", familyDiscount: "家庭成员：THB 750,000/人（促销至2026年12月31日，原价THB 1,000,000）",
      privileges: ["5年可续签证（覆盖10年）","每次入境可延长1年","VIP接待","加速移民","专属贵宾室","每年35积分","移民服务和90天报到","驾照协助","银行开户协助","商务网络","家庭成员：THB 1,000,000/人（促销THB 750,000至2026年12月31日）","多语言联络中心24/7"],
      privilegeGroups: [
        { title: "签证权益", items: [
          "5年可续多次入境签证（覆盖全部10年）",
          "每次入境可延长1年居留期",
          "移民服务及90天报到"
        ] },
        { title: "机场权益", items: [
          "到达和离境VIP接待与陪同",
          "加速移民及护照检查",
          "专属到达和离境贵宾室"
        ] },
        { title: "生活方式与行政权益", items: [
          "每年35特权积分可兑换",
          "驾照办理协助",
          "银行开户协助",
          "商务网络支持",
          "符合资格的家庭成员：配偶、父母、子女（THB 1,000,000/人）",
          "会员联络中心：英语24/7（韩语、中文、日语）"
        ] }
      ],
      conditions: [{ label: "升级", value: "是" },{ label: "可续期", value: "是" },{ label: "可转让", value: "不可转让/不可退款" }],
      faqs: [
        { q: "泰国精英白金卡会员费用是多少？", a: "白金卡会员一次性费用为 THB 1,500,000。家庭成员可在2026年12月31日前按每人75万泰铢加入（原价 THB 1,000,000）。" },
        { q: "白金卡会员有效期多长？", a: "白金卡会员有效期为10年。" },
        { q: "白金卡会员包含多少特权积分？", a: "白金卡会员每年获得35特权积分。" },
        { q: "白金卡会员可以在泰国停留满一年吗？", a: "可以。会员每次入境获得1年居留章，若在到期前未离境，可在移民局办理延期。" },
        { q: "白金卡会员可以添加家庭成员吗？", a: "可以。符合资格的家庭成员——配偶、父母和子女——可在2026年12月31日前按每人75万泰铢加入（原价 THB 1,000,000），每人均获得自己的签证及全部特权。" },
        { q: "持白金卡会员可以在泰国工作吗？", a: "不可以。泰国精英／Thailand Privilege 不能替代工作许可。需要工作的会员必须取得相应的工作授权。" },
        { q: "持白金卡会员可以开设泰国银行账户吗？", a: "可以。银行开户协助是会员可享的核心支持服务之一。" },
        { q: "白金卡会员可以退款吗？", a: "不可以。会员资格不可转让、不可退款。" },
        { q: "我之后可以从白金卡升级吗？", a: "可以。白金卡会员可升级至钻石卡或尊享卡等更高等级。" }
      ],
      comparison: {
        title: "白金卡 vs 金卡：10年还是5年？",
        intro: "金卡为个人提供5年会员，而白金卡将有效期延长至10年，增加更多特权积分并开放家庭会员。白金卡适合计划长期居留或希望纳入亲属的会员。",
        colA: "金卡",
        colB: "白金卡",
        highlight: 1,
        rows: [
          { feature: "有效期", a: "5年", b: "10年" },
          { feature: "会员费", a: "THB 900,000", b: "THB 1,500,000" },
          { feature: "每年特权积分", a: "20", b: "35" },
          { feature: "家庭会员", a: "不可用", b: "THB 1,000,000/人" },
          { feature: "适合人群", a: "个人，5年规划", b: "更长居留＋家庭选项" }
        ]
      }
    },
    diamond: {
      metaTitle: "泰国精英钻石卡 – 15年签证 | THB 2,500,000", metaDescription: "钻石卡：15年签证，每年55积分，每位家庭成员节省100万泰铢。",
      badge: "15年高级会员", title: "钻石卡会员", tagline: "十五年无与伦比的奢华",
      intro: "钻石精英会员象征着精致与无与伦比的奢华，15年有效期，每年55积分，一次性费用THB 2,500,000。",
      points: "55", cta: "申请钻石卡", familyDiscount: "家庭成员：THB 750,000/人（促销至2026年12月31日，原价THB 1,500,000）",
      privileges: ["5年可续签证（覆盖15年）","每次入境可延长1年","VIP接待","加速移民","专属贵宾室","每年55积分","移民服务和90天报到","驾照协助","银行开户协助","商务网络","家庭成员：THB 1,500,000/人（促销THB 750,000至2026年12月31日）","多语言联络中心24/7"],
      privilegeGroups: [
        { title: "签证权益", items: [
          "5年可续多次入境签证（覆盖全部15年）",
          "每次入境可延长1年居留期",
          "移民服务及90天报到"
        ] },
        { title: "机场权益", items: [
          "到达和离境VIP接待与陪同",
          "加速移民及护照检查",
          "专属到达和离境贵宾室"
        ] },
        { title: "生活方式与行政权益", items: [
          "每年55特权积分可兑换",
          "驾照办理协助",
          "银行开户协助",
          "商务网络支持",
          "符合资格的家庭成员：配偶、父母、子女（THB 1,500,000/人）",
          "会员联络中心：英语24/7（韩语、中文、日语）"
        ] }
      ],
      conditions: [{ label: "升级", value: "是" },{ label: "可续期", value: "是" },{ label: "可转让", value: "不可转让/不可退款" }],
      faqs: [
        { q: "泰国精英钻石卡会员费用是多少？", a: "钻石卡会员一次性费用为 THB 2,500,000。家庭成员可在2026年12月31日前按每人75万泰铢加入（原价 THB 1,500,000）。" },
        { q: "钻石卡会员有效期多长？", a: "钻石卡会员有效期为15年。" },
        { q: "钻石卡会员包含多少特权积分？", a: "钻石卡会员每年获得55特权积分。" },
        { q: "钻石卡会员可以在泰国停留满一年吗？", a: "可以。会员每次入境获得1年居留章，若在到期前未离境，可在移民局办理延期。" },
        { q: "钻石卡会员可以添加家庭成员吗？", a: "可以。符合资格的家庭成员——配偶、父母和子女——可在2026年12月31日前按每人75万泰铢加入（原价 THB 1,500,000），每人均获得自己的签证及全部特权。" },
        { q: "持钻石卡会员可以在泰国工作吗？", a: "不可以。泰国精英／Thailand Privilege 不能替代工作许可。需要工作的会员必须取得相应的工作授权。" },
        { q: "持钻石卡会员可以开设泰国银行账户吗？", a: "可以。银行开户协助是会员可享的核心支持服务之一。" },
        { q: "钻石卡会员可以退款吗？", a: "不可以。会员资格不可转让、不可退款。" },
        { q: "我之后可以从钻石卡升级吗？", a: "可以。钻石卡会员可升级至尊享卡——我们仅限受邀的旗舰等级。" }
      ],
      comparison: {
        title: "钻石卡 vs 白金卡：选择哪种长期会员？",
        intro: "白金卡覆盖10年，而钻石卡将您的居留延长至15年，每年获得更多特权积分。两者均提供家庭会员；钻石卡适合愿意承诺仅次于仅限受邀的尊享卡之最长实际期限的会员。",
        colA: "白金卡",
        colB: "钻石卡",
        highlight: 1,
        rows: [
          { feature: "有效期", a: "10年", b: "15年" },
          { feature: "会员费", a: "THB 1,500,000", b: "THB 2,500,000" },
          { feature: "每年特权积分", a: "35", b: "55" },
          { feature: "家庭会员", a: "THB 1,000,000/人", b: "THB 1,500,000/人" },
          { feature: "适合人群", a: "10年规划", b: "15年规划，更多积分" }
        ]
      }
    },
    reserve: {
      metaTitle: "泰国精英尊享卡 – 20年签证 | THB 5,000,000", metaDescription: "尊享卡：仅限邀请，20年会员，每年120积分，可转让。",
      badge: "20年仅限邀请", title: "尊享卡会员", tagline: "泰国特权的巅峰",
      intro: "专为追求极致奢华与尊贵的人士设计，尊享卡是泰国精英项目的最高荣誉，仅限受邀者申请。20年有效期，每年120积分，两个十年的无与伦比体验。",
      points: "120", cta: "咨询尊享卡", familyDiscount: "家庭成员：THB 750,000/人（促销至2026年12月31日，原价THB 2,000,000）",
      privileges: ["5年可续签证（覆盖20年）","每次入境可延长1年","VIP接待","加速移民","专属贵宾室","每年120积分","移民服务和90天报到","驾照协助","银行开户协助","商务网络","会员可转让","多语言联络中心24/7"],
      privilegeGroups: [
        { title: "签证权益", items: [
          "5年可续多次入境签证（覆盖全部20年）",
          "每次入境可延长1年居留期",
          "移民服务及90天报到"
        ] },
        { title: "机场权益", items: [
          "到达和离境VIP接待与陪同",
          "加速移民及护照检查",
          "专属到达和离境贵宾室"
        ] },
        { title: "生活方式与行政权益", items: [
          "每年120特权积分可兑换",
          "驾照办理协助",
          "银行开户协助",
          "商务网络支持",
          "会员资格可转让",
          "符合资格的家庭成员：配偶、父母、子女（THB 2,000,000/人）",
          "会员联络中心：英语24/7（韩语、中文、日语）"
        ] }
      ],
      conditions: [{ label: "邀请", value: "仅限邀请" },{ label: "可转让", value: "是" },{ label: "可续期", value: "是" }],
      faqs: [
        { q: "泰国精英尊享卡会员费用是多少？", a: "尊享卡会员一次性费用为 THB 5,000,000。家庭成员可在2026年12月31日前按每人75万泰铢加入（原价 THB 2,000,000）。" },
        { q: "尊享卡会员有效期多长？", a: "尊享卡会员有效期为20年——所有泰国精英等级中最长的有效期。" },
        { q: "如何获得尊享卡会员邀请？", a: "尊享卡会员仅限邀请。请联系我们的团队表达兴趣，我们将评估资格并指导您完成流程。" },
        { q: "尊享卡会员包含多少特权积分？", a: "尊享卡会员每年获得120特权积分——所有等级中最高的配额。" },
        { q: "尊享卡会员可以转让吗？", a: "可以。尊享卡是唯一可转让的泰国精英会员，让奢华传承得以延续。" },
        { q: "尊享卡会员可以添加家庭成员吗？", a: "可以。符合资格的家庭成员——配偶、父母和子女——可在2026年12月31日前按每人75万泰铢加入（原价 THB 2,000,000），每人在整个20年期间均获得自己的签证及全部尊享卡特权。" },
        { q: "持尊享卡会员可以在泰国工作吗？", a: "不可以。泰国精英／Thailand Privilege 不能替代工作许可。需要工作的会员必须取得相应的工作授权。" },
        { q: "持尊享卡会员可以开设泰国银行账户吗？", a: "可以。银行开户协助是会员可享的核心支持服务之一。" },
        { q: "尊享卡会员可以在泰国停留满一年吗？", a: "可以。会员每次入境获得1年居留章，若在到期前未离境，可在移民局办理延期。" }
      ],
      comparison: {
        title: "尊享卡 vs 钻石卡：终极等级",
        intro: "钻石卡提供15年高端会员，而尊享卡是仅限受邀的旗舰等级——20年居留、最高的特权积分配额，以及项目中唯一可转让的会员资格。",
        colA: "钻石卡",
        colB: "尊享卡",
        highlight: 1,
        rows: [
          { feature: "有效期", a: "15年", b: "20年" },
          { feature: "会员费", a: "THB 2,500,000", b: "THB 5,000,000" },
          { feature: "每年特权积分", a: "55", b: "120" },
          { feature: "家庭会员", a: "THB 1,500,000/人", b: "THB 2,000,000/人" },
          { feature: "可转让", a: "否", b: "是" },
          { feature: "申请方式", a: "公开申请", b: "仅限邀请" }
        ]
      }
    },
  },

  // Visa page
  visa: {
    metaTitle: "Thailand Elite 签证与 Thailand Privilege 签证 — 5至20年长期居留签证",
    metaDescription: "Thailand Elite 签证（又称 Thailand Privilege 签证或 Privilege Entry Visa / PE）是泰国最长多次入境签证 — 有效期5至20年，可全程续签，无需出境。申请要求、费用及常见问题。",
    badge: "泰国特权入境签证（PE）",
    title: "Thailand Elite 签证 — Thailand Privilege 签证指南",
    subtitle: "Thailand Elite 签证（又称 Thailand Privilege 签证）是泰国王国可签发的最长多次入境签证 — 为 Thailand Privilege Card 会员提供5至20年的无忧长期居留。",
    whatIsTitle: "什么是 Thailand Elite 签证（Thailand Privilege 签证）？",
    intro1: "Thailand Elite 签证 — 官方名称为 Privilege Entry Visa（PE），通常也称为 Thailand Privilege 签证 — 是专为 Thailand Elite 会员提供的特殊长期签证。该签证归类于旅游签证，根据所选会员等级，授予在泰国王国5年、10年、15年或20年的合法居留资格。",
    intro2: "Thailand Elite 签证是一种多次入境签证，在整个会员期内可续签，每次入境可申请延长1年居留期。Thailand Elite 会员无需像其他签证类型那样每隔60至90天离境，可在泰国持续居留，并在每次抵达时享受快速通关服务。",
    intro3: "无论您称其为 Thailand Elite Visa、Thai Elite Visa、Thailand Privilege Visa 还是 Thailand Privilege Entry Visa，均指同一官方长期签证，通过同一 Thailand Elite 项目签发。拥有来自50多个国家逾40,000名会员，Thailand Elite 是亚洲历史最悠久、最成熟的会员制居留项目。",
    rebrandTitle: "Thailand Elite 签证与 Thailand Privilege 签证 — 两个名称，同一项目",
    rebrandIntro: "许多申请人询问 Thailand Elite 签证与 Thailand Privilege 签证是否为同一签证。简而言之，是的 — 两个名称指向完全相同的长期签证，在同一官方项目下签发。以下说明两者名称的关系。",
    rebrandPoints: [
      { label: "项目品牌", value: "Thailand Elite — 自2003年起在全球广泛使用的项目名称，至今仍是会员、代理商和媒体最常引用的名称。" },
      { label: "签发机构", value: "签证本身由泰国移民局签发。背后的会员资格与特权卡由 Thailand Privilege Card Co., Ltd. 运营 — 该公司是泰国国家旅游局（TAT）下属的国有企业。Thailand Elite 是官方销售与服务渠道。" },
      { label: "签证名称", value: "Thailand Elite 签证与 Thailand Privilege 签证是同一签证的两种互通名称。部分资料也称其为 Thai Elite Visa 或 Thailand Privilege Entry Visa。" },
      { label: "官方签证类别", value: "Privilege Entry Visa（PE）— 泰国移民局在您护照上加盖的法定签证类别，是两种品牌名称背后的正式技术名称。" },
    ],
    rebrandConclusion: "实际上，所有名称均指向同一多年期居留签证，通过 Thailand Elite 会员资格获得，由 Thailand Privilege Card Co., Ltd. 签发 — 申请一次，使用任一名称皆可放心。",
    rebrandLink: "了解更多关于 Thailand Privilege Card 的信息",
    rebrandApplyCta: "立即申请 Thailand Elite",
    locationsTitle: "在哪里办理 Thailand Elite 签证",
    locationsSubtitle: "您的 Thailand Elite 签证将贴附于护照上（至少需要3页空白页），可在以下地点办理。",
    locations: {
      suvarnabhumi: { title: "曼谷素万那普 Suvarnabhumi 国际机场", desc: "仅限乘坐国际航班抵达时办理。请通过会员联络中心至少提前5个工作日预约。" },
      phuket: { title: "普吉国际机场", desc: "仅限乘坐国际航班抵达时办理。请通过会员联络中心至少提前5个工作日预约。" },
      chiangMai: { title: "清迈国际机场", desc: "仅限乘坐国际航班抵达时办理。请通过会员联络中心至少提前5个工作日预约。" },
      chaengWattana: { title: "移民局，曾卫他纳 Chaeng Wattana", desc: "仅限预约办理——提供贵宾候机室。请通过会员联络中心至少提前7个工作日预约。视名额及排队情况而定。" },
    },
    dutiesTitle: "Thailand Elite 签证持有人的义务",
    dutiesSubtitle: "获得 Privilege Entry Visa 后，您的义务相比其他签证类型大为简化。",
    duties: {
      ninetyDay: { title: "90天报到（TM47）", desc: "所有在泰外国人（包括 Thailand Elite 签证持有人），若连续停留超过90天，须每90天报告一次地址。离境后重新计算。泰国精英工作人员可协助在曼谷（Sathorn路总部，每周二16:30前）、芭提雅、普吉和清迈办理报到。您也可以在线、邮寄或亲赴最近的移民局自行办理。" },
      annualExtension: { title: "年度居留延期", desc: "尽管您的 Thailand Elite 签证有效期达5年以上，但每次入境的居留期限为1年。若您在一整年内不打算出境，请联系会员联络中心，该中心将提供一封官方信函，协助您办理再延长一年的居留手续。流程十分简便——填写一份表格，附上信函和护照即可。可在入境章到期前30天内申请。" },
    },
    workTitle: "能否凭 Thailand Elite 签证在泰国工作？",
    workDesc1: "Privilege Entry Visa 属于旅游签证类别，因此不直接允许您申请工作许可。但是，若您的业务和收入来源于境外，您可以在持有 Thailand Elite 签证的同时远程管理您的事务。您可以担任泰国注册公司的股东或董事，但不能以此身份积极受雇。",
    workDesc2: "若您需要工作许可，可单独申请非移民B类签证（Non-Immigrant B Visa）——您的 Thailand Elite 签证在到期前仍保持有效。某些会员还可能符合 Flexible Plus 计划的资格，该计划允许将 PE 签证转换为非移民签证以申请工作许可。请联系我们的团队，根据您的具体情况获取专业指导。",
    faqTitle: "Thailand Elite 签证 — 常见问题",
    requirementsTitle: "Thailand Elite 签证申请要求",
    requirementsSubtitle: "通过 Thailand Elite 项目申请 Privilege Entry Visa，申请人须满足以下条件。",
    tdac: {
      title: "入境前完成 TDAC",
      desc: "Thailand Elite 会员应在进入泰国前3天内填写泰国数字入境卡（Thailand Digital Arrival Card），并将确认信息随旅行证件一同保存。",
      link: "阅读 TDAC 指南",
    },
    howToApplyLink: "了解如何成为 Thailand Elite 会员 →",
    facts: {
      duration: { title: "5年有效期", desc: "可续多次入境签证，泰国最长。与您的会员到期日挂钩。" },
      multiEntry: { title: "无限次出入境", desc: "在 Thailand Elite 签证有效期内自由出入泰国。" },
      extension: { title: "1年居留延期", desc: "每次入境可申请延长一年居留，无需离境。" },
      renewal: { title: "免费续签", desc: "在会员期内，Privilege Entry Visa 免费续签。" },
    },
    faqs: {
      whatIsElite: { q: "什么是 Thailand Elite 签证？", a: "Thailand Elite 签证是泰国移民局向 Thailand Elite 项目会员签发的长期多次入境签证。官方名称为 Privilege Entry Visa（PE），通常也称为 Thailand Privilege 签证，是泰国可获得的最长签证 — 根据会员等级，有效期为5年、10年、15年或20年 — 每次入境可申请延长1年居留期，无需出境。" },
      whatIsPrivilege: { q: "什么是 Thailand Privilege 签证？", a: "Thailand Privilege 签证是 Thailand Elite 签证的另一种称呼 — 即授予 Thailand Elite 会员的同一长期签证。其名称来源于签发会员特权卡的泰国官方国有企业 Thailand Privilege Card Co., Ltd.。该签证法定类别为 Privilege Entry Visa（PE），根据会员等级，有效期为5年、10年、15年或20年。" },
      sameVisa: { q: "Thailand Elite 签证与 Thailand Privilege 签证是同一签证吗？", a: "是的。Thailand Elite 签证与 Thailand Privilege 签证是同一签证的两种名称，通过同一项目签发。Thailand Elite 是全球公认的项目品牌；Thailand Privilege Card Co., Ltd. 是签发会员卡并运营该项目的泰国国有企业。法定签证类别 — Privilege Entry Visa（PE）— 以及会员权益完全相同。" },
      validity: { q: "Thailand Elite / Thailand Privilege 签证的有效期是多长？", a: "签证有效期为5年、10年、15年或20年，取决于您的 Thailand Elite 会员等级 — Bronze（5年）、Gold（5年可续）、Platinum（10年）、Diamond（15年）和 Reserve（20年，限受邀）。该签证为多次入境签证，每次入境可申请延长1年居留期，在会员到期前免费续签。" },
      cost: { q: "Thailand Elite / Thailand Privilege 签证的费用是多少？", a: "Thailand Elite 会员费起价为 THB 650,000（约18,000美元）的Bronze 5年等级，最高为 THB 5,000,000 的Reserve 20年等级。费用为一次性会员费 — 无年度续费，签证本身已包含在内。请参阅我们的会员资格页面了解当前各等级详情。" },
      obtain: { q: "如何获得 Thailand Elite 签证？", a: "成为会员并获得 Thailand Elite 会员ID后，可向会员联络中心申请，5个工作日内即可在您选择的地点将签证贴附于护照：曼谷 Suvarnabhumi 机场、普吉机场、清迈机场、Chaeng Wattana 移民局，或境外泰国领事馆。" },
      where: { q: "在哪里领取 Privilege Entry Visa？", a: "您的 Thailand Elite 签证将贴附于护照上（至少需要3页空白页），可在抵达曼谷 Suvarnabhumi 机场或普吉机场的国际航班时办理，也可在曼谷 Chaeng Wattana 移民局或您所在国家的 Royal Thai Consulate 办理。" },
      duties: { q: "Thailand Elite 签证持有人的义务是什么？", a: "Thailand Elite / Thailand Privilege 签证持有人须完成90天地址报到（TM47），若连续居留超过1年，还需申请年度居留延期。泰国精英工作人员可在曼谷、芭提雅、普吉和清迈协助办理上述两项手续。" },
      reporting: { q: "什么是90天报到要求？", a: "所有在泰国连续停留超过90天的外国人须每90天报告一次地址。离境后计数重置。泰国精英在曼谷（Sathorn路）、芭提雅、普吉和清迈提供代办服务，您也可以在线或邮寄自行办理。" },
      extension: { q: "年度居留延期如何操作？", a: "尽管 Thailand Privilege 签证有效期为多年，但每次居留限1年。若不打算出境，请联系会员服务获取延期官方信函。流程简便，可在入境章到期前30天内申请。" },
      work: { q: "能否凭 Thailand Elite / Thailand Privilege 签证工作？", a: "Privilege Entry Visa 不包含工作许可。若您的业务和收入来源于海外，可以持有 Thailand Elite 签证并远程管理事务。您可以担任泰国公司的股东或董事，但不能积极受雇。如需工作许可，可单独申请非移民B类签证；部分会员可能符合 Flexible Plus 计划资格，允许将 PE 签证转换为非移民签证以申请工作许可。" },
      family: { q: "我的家人也能申请 Thailand Privilege 签证吗？", a: "可以。多个 Thailand Privilege Card 等级（Gold Family、Platinum Family、Diamond Family、Reserve）包含为配偶、父母和子女设置的附属会员资格，每位成员均可在相同条件下获得自己的 Thailand Privilege 签证。请参阅我们的家庭会员页面了解等级资格和价格。" },
    },
    requirements: [
      "持有被接受国家的外国护照，至少3页空白页及1年以上有效期",
      "在泰国无签证逾期记录",
      "无年龄限制（Reserve 会员要求申请人年满20周岁）",
      "在任何国家无监禁判决（过失罪除外）",
      "未被宣布破产",
      "未被宣布为精神不健全、无行为能力或准无行为能力人",
      "申请须经移民局批准",
    ],
  },

  // Thailand Privilege Card entity page
  thailandPrivilegeCard: {
    metaTitle: "Thailand Privilege Card — Thailand Elite 签证背后的官方会员资格",
    metaDescription: "Thailand Privilege Card 是由 Thailand Privilege Card Co., Ltd. 签发的官方会员资格 — 即提供 Thailand Elite 长期签证的机构。5至20年签证、快速通关、礼宾及生活方式特权。",
    badge: "Thailand Privilege Card",
    title: "Thailand Privilege Card — Thailand Elite 背后的官方会员资格",
    subtitle: "Thailand Privilege Card Co., Ltd. 是签发 Thailand Elite 项目会员资格的泰国官方国有企业。一次申请，即可解锁5至20年长期居留签证、快速通关、政府礼宾及精选生活方式特权。",
    heroAuthorized: "授权全球销售与服务代理（GSSA）",
    facts: {
      since: { value: "2003", label: "项目创立年份" },
      members: { value: "40,000+", label: "全球会员数量" },
      countries: { value: "50+", label: "代表国籍数量" },
      official: { value: "Royal Thai", label: "国有企业运营方" },
    },
    whatIsTitle: "什么是 Thailand Privilege Card？",
    whatIs1: "Thailand Privilege Card 是授予外国人在泰国合法长期居留权的官方会员资格。由 Thailand Privilege Card Co., Ltd. 签发，该公司是隶属于泰国旅游与体育部的国有企业，自2003年起运营 Thailand Elite 项目。",
    whatIs2: "每份会员资格均附带 Thailand Elite 签证 — 又称 Thailand Privilege 签证，法定类别为 Privilege Entry Visa（PE）。这是一种多次入境长期签证，根据等级有效期为5至20年，并附带丰厚的年度 Privilege Points，可在住宿、旅行、休闲、健康和财富管理合作伙伴处兑换。会员享有在主要泰国机场的快速通关服务、政府礼宾支持及全天候会员联络中心协助。",
    whatIs3: "Thailand Elite 是全球公认的项目品牌；Thailand Privilege Card Co., Ltd. 是签发会员资格和签证的机构。两个名称均指向同一官方项目 — 亚洲历史最悠久、最成熟的会员制居留计划。",
    tiersTitle: "Thailand Elite 会员等级",
    tiersIntro: "五个 Thailand Elite 等级，一张 Thailand Privilege Card。选择符合您生活方式的居留年限与 Privilege Points 配额。",
    tiers: {
      reserve: {
        name: "Reserve",
        years: "20年",
        desc: "仅限受邀。旗舰等级，Privilege Points 配额最高，含家庭会员资格及专属礼宾服务。",
        price: "THB 5,000,000",
      },
      diamond: {
        name: "Diamond",
        years: "15年",
        desc: "长期承诺，年度 Privilege Points 丰厚，提供家庭会员选项。",
        price: "THB 2,500,000",
      },
      platinum: {
        name: "Platinum",
        years: "10年",
        desc: "深受全球商界精英青睐的等级 — 10年居留权，附高端礼宾服务及 Privilege Points。",
        price: "THB 1,500,000",
      },
      gold: {
        name: "Gold",
        years: "5年",
        desc: "入门长期居留等级，含核心特权及机场快速通关服务，可续签。",
        price: "THB 900,000",
      },
      bronze: {
        name: "Bronze",
        years: "5年",
        desc: "最易获取的 Thailand Privilege Card 等级 — 5年长期居留权，含基本权益。",
        price: "THB 650,000",
      },
    },
    tiersLink: "比较所有 Thailand Elite 等级",
    benefitsTitle: "Thailand Elite 会员权益",
    benefitsIntro: "Thailand Privilege Card 激活当日即可享受的一切 — 签证、服务及专属 Thailand Elite 会员通道。",
    benefits: {
      longStay: {
        title: "5至20年长期居留签证",
        desc: "Thailand Elite 签证 — 又称 Thailand Privilege 签证（Privilege Entry Visa）— 在整个会员期内提供多次入境居留权，每次入境无需离境即可续签。",
      },
      fastTrack: {
        title: "快速通关服务",
        desc: "曼谷 Suvarnabhumi、普吉和清迈机场的个性化机场服务 — 精英个人助理在登机口迎接您并引导快速通关和行李提取。",
      },
      concierge: {
        title: "24/7 会员礼宾",
        desc: "通过 Thailand Elite 会员联络中心提供政府及生活方式礼宾服务 — 签证手续、移民协助、餐厅预订、翻译等。",
      },
      wellness: {
        title: "健康体检与健康服务",
        desc: "在顶级国际标准医院进行年度健康筛查，在泰国各合作度假村享受免费水疗和健康套餐。",
      },
      lifestyle: {
        title: "酒店、高尔夫及生活方式",
        desc: "在领先酒店连锁享受专属优惠和免费住宿，高尔夫球场权益、VIP购物通道及精选生活方式体验。",
      },
      noBorderRuns: {
        title: "告别出境奔波",
        desc: "忘记60天旅游签证和90天出境跑。Thailand Privilege Card 以单一长期签证解决所有签证烦恼。",
      },
    },
    gssa: {
      badge: "授权 GSSA",
      title: "通过屡获殊荣的授权渠道申请",
      desc1: "Dreamond 是 Thailand Privilege Card Co., Ltd. 的授权全球销售与服务代理（GSSA）— 即 Thailand Elite 项目背后的官方签发机构 — 持有国家机构颁发的 SA21/012 牌照。作为官方指定合作伙伴，我们全程管理申请事宜 — 从资格核查到背景审查、付款协调和签证加注 — 不收取官方会员费以外的额外费用。",
      desc2: "我们的团队已协助来自50多个国籍的数千名会员完成 Thailand Elite 申请，提供7种语言支持、透明定价，并在各大评价平台获得4.8/5的评分。无论您申请的是 Bronze、Gold、Platinum、Diamond 还是 Reserve，通过 GSSA 申请意味着拥有单一联络人并直接获得 Thailand Elite 工作人员的支持。",
      tag1: "屡获殊荣的服务",
      tag2: "持牌 GSSA（SA21/012）",
      tag3: "Thailand Elite 直接渠道",
    },
    faqTitle: "Thailand Privilege Card — 常见问题",
    faqIntro: "关于 Thailand Privilege Card、Thailand Elite 签证、等级及申请方式的最常见问题。",
    faqs: {
      whatIs: {
        q: "什么是 Thailand Privilege Card？",
        a: "Thailand Privilege Card 是泰国唯一会员制居留项目 — Thailand Elite — 背后的官方会员卡。由 Thailand Privilege Card Co., Ltd. 签发，该公司是旅游与体育部下属的国有企业。会员获得长期签证（5至20年）、快速通关、政府礼宾及生活方式特权。",
      },
      thailandElite: {
        q: "Thailand Privilege Card 与 Thailand Elite 是同一项目吗？",
        a: "是的 — 两者指向同一官方项目。Thailand Elite 是自2003年起全球公认的项目品牌；Thailand Privilege Card Co., Ltd. 是签发会员卡并运营该项目的泰国国有企业。无论您读到的是「Thailand Elite」还是「Thailand Privilege Card」，会员资格、签证和权益完全相同。",
      },
      tiers: {
        q: "Thailand Elite / Thailand Privilege Card 有哪些等级？",
        a: "共有五个等级：Bronze（5年，THB 650,000）、Gold（5年可续，THB 900,000）、Platinum（10年，THB 1,500,000）、Diamond（15年，THB 2,500,000）和 Reserve（20年，限受邀，THB 5,000,000）。每个等级均包含 Thailand Elite 签证及年度 Privilege Points 配额。",
      },
      cost: {
        q: "Thailand Privilege Card 的费用是多少？",
        a: "会员费起价为 THB 650,000（约18,000美元）的 Bronze 5年等级，最高为 THB 5,000,000 的 Reserve 20年仅限受邀等级。费用为一次性会员付款 — 无年度续费，签证本身已包含在内。",
      },
      validity: {
        q: "Thailand Privilege Card 的有效期是多长？",
        a: "您的会员卡及所含 Thailand Elite 签证在您所在等级的完整期限内有效 — 5年、10年、15年或20年 — 每次入境授予可续签1年居留期。Gold 会员可续签其5年等级；其他等级在期满后结束。",
      },
      visa: {
        q: "持 Thailand Privilege Card 获得哪种签证？",
        a: "每位会员均获得 Thailand Elite 签证 — 又称 Thailand Privilege 签证，官方类别为 Privilege Entry Visa（PE）。这是一种附带快速通关的多次入境长期签证，在整个会员期内有效，到期前免费续签。",
      },
      howToApply: {
        q: "如何申请 Thailand Elite / Thailand Privilege Card 会员资格？",
        a: "申请全程在线完成。提交护照、填写会员申请表，并通过背景审查（通常需4至12周）。仅在获批后付款。作为授权 GSSA，我们全程处理所有事宜 — 从初步资格核查到签证加注 — 不收取官方会员费以外的额外费用。",
      },
      gssa: {
        q: "什么是 GSSA，为什么要通过 GSSA 申请？",
        a: "全球销售与服务代理（GSSA）是由 Thailand Privilege Card Co., Ltd. 官方授权接收和处理 Thailand Elite 会员申请的合作伙伴。通过 GSSA 申请，您将获得单一英语联络人、文件准备支持以及直接上报 Thailand Elite 工作人员的渠道 — 与单独申请相比不产生额外费用。",
      },
      officialChannel: {
        q: "Dreamond 是 Thailand Elite 的官方合作伙伴吗？",
        a: "是的。Dreamond 是持有相关国家机构颁发 SA21/012 牌照的授权全球销售与服务代理，已协助来自50多个国籍的数千名获批会员，提供7种语言支持，在各大评价平台获得4.8/5的评分。",
      },
      family: {
        q: "我的家人也可以加入 Thailand Elite 吗？",
        a: "可以。多个等级（Gold Family、Platinum Family、Diamond Family 和 Reserve）包含为配偶、父母和子女设置的附属会员资格 — 每位成员在同一会员资格下获得自己的 Thailand Elite 签证。",
      },
    },
    relatedTitle: "探索 Thailand Elite 项目",
    related: {
      visa: "Thailand Elite 签证",
      points: "Privilege Points",
      bankAccount: "开设泰国银行账户",
    },
    bottomCta: {
      title: "准备好加入 Thailand Elite 了吗？",
      desc: "在授权 GSSA 的帮助下成为 Thailand Elite 会员。免费资格核查、7种语言支持，以及从申请到签证加注的全程指导。",
      button: "立即申请 Thailand Elite",
    },
  },

  // Privilege Points page
  privilegePoints: {
    metaTitle: "泰国精英特权积分 – 兑换专属权益与服务",
    metaDescription: "了解泰国精英特权积分——兑换豪华酒店住宿、VIP机场接送、水疗、购物和财富顾问等专属服务。",
    badge: "特权积分制度",
    title: "特权积分",
    subtitle: "自由选择无限特权——用积分兑换最适合您的服务与体验。",
    intro1: "<1>2023年10月推出的全新泰国精英卡（Thailand Privilege Card）会籍</1>的一大亮点，是每个项目均附带会员可每年使用的特权积分，用于兑换您选择的服务和特权。",
    intro2: "通过特权积分，您可以自由享受真正渴望的服务与特权。从机场私人接送、酒店和餐厅折扣，到健康疗养、购物和娱乐，现在一切均可按需选择，数量取决于您所加入的泰国精英计划的积分额度。",
    intro3: "积分按年分配，可在五大类别中兑换：住宿、旅行、休闲、健康和财富。每个类别均精选泰国顶级合作伙伴，确保每次兑换都能带来与您的泰国精英会员身份相称的尊享体验。",
    tableTitle: "各等级积分一览",
    tableSubtitle: "等级越高，年度特权积分越多，灵活性更大，可享受更多专属体验。",
    perYear: "每年",
    howItWorksTitle: "特权积分的使用方式",
    howItWorksDesc: "积分在每个会员年度开始时分配，可在全年任意时间兑换五大类别中的任何可用服务。未使用积分不累计至下一年度。选择最符合您生活方式的会员等级，尽享量身定制的泰国生活体验。",
    compareButton: "对比会员等级",
    privilegeBookButton: "查阅 Privilege Book 2026",
    privilegeBookTitle: "Privilege Book 2026",
    openInNewTab: "在新标签页中打开",
    categories: {
      stay: {
        title: "住宿",
        description: "在泰国顶级酒店和度假村享受免费酒店会员、额外免费住宿夜和特别礼遇。从普吉岛的海滨别墅到曼谷的豪华套房，特权积分为您开启卓越的住宿体验。",
        items: [
          "顶级酒店连锁免费会员",
          "在合作酒店入住可享额外免费一晚",
          "住宿期间享受合作酒店特别礼遇",
          "畅享泰国各地专属度假村体验"
        ]
      },
      travel: {
        title: "旅行",
        description: "从踏上泰国的那一刻起，享受机场VIP迎宾服务、豪华轿车接送和专属贵宾室通道。特权积分还可兑换私人飞机、航空公司、游艇和租车的特别优惠。",
        items: [
          "精英个人助理机场VIP迎宾和协助服务",
          "豪华车辆机场接送（短程和长程）",
          "泰国各大机场专属贵宾室通道",
          "私人飞机、航空公司、游艇和租车特惠"
        ]
      },
      leisure: {
        title: "休闲",
        description: "泰国是懂得享受生活的人的乐园。用特权积分兑换VIP购物体验、共享办公空间、世界级娱乐和遍布全国的文化活动专属通道。",
        items: [
          "高端商场专属折扣与特权",
          "高端商场贵宾休息室通道",
          "私人购物助理服务",
          "高端地点共享办公空间",
          "世界级演唱会及活动门票",
          "领先影院VIP电影场次"
        ]
      },
      wellbeing: {
        title: "健康",
        description: "泰国以世界级医疗和健康设施享誉全球。用特权积分兑换在顶级医院的全面健康体检、健身会员资格，以及全国最优质健康中心的水疗和健康套餐。",
        items: [
          "在国际标准医院免费年度健康体检",
          "免费酒店连锁健身会员",
          "高端水疗、健康和保健套餐",
          "畅享泰国顶级健康度假村和中心"
        ]
      },
      wealth: {
        title: "财富",
        description: "对于重视财富增值和人脉拓展的会员，特权积分可换取专属财富顾问服务、高端社交活动，以及专为在泰国际居民设计的定制保险方案。",
        items: [
          "顶级机构财富与投资顾问服务",
          "专属社交活动、研讨会和商务论坛",
          "专为泰国外籍人士定制的特别保险套餐",
          "优先获得金融和法律咨询服务"
        ]
      },
    },
  },

  // Family Visa page
  nextMemberPromo: {
    badge: "限时优惠",
    title: "家庭成员（Next Member）促销：每人75万泰铢",
    desc: "为白金、钻石或尊享会员添加配偶、父母或子女，每人仅需75万泰铢，而非常规家庭成员费用。每位家庭成员均获得独立签证和全部特权。",
    until: "有效期至2026年12月31日",
    regular: "原价",
    perPerson: "每人",
    cta: "家庭会员详情",
    heroLabel: "家庭成员（促销）",
  },
  family: {
    metaTitle: "泰国精英家庭签证 – 家庭长期居留签证与特权",
    metaDescription: "了解泰国精英家庭会员计划。白金、钻石和尊享等级提供每位成员最高100万泰铢的家庭折扣。",
    badge: "家庭会员",
    title: "为您的家庭提供长期签证与特权",
    subtitle: "泰国精英为白金、钻石和尊享等级提供独家家庭会员选项 — 让您的配偶、父母和子女以优惠价格享受相同的签证和特权。",
    intro: "全家移居泰国？泰国精英让这一切变得简单。每位家庭成员都将获得自己的5年可续签多次入境签证、机场快速通道、礼宾服务和所有特权 — 价格大幅优惠。",
    promoTitle: "🔥 家庭促销 — 每位家庭成员75万泰铢，截至2026年12月31日",
    promoDesc: "白金、钻石和尊享会员家庭促销：2026年12月31日前，家庭成员每人75万泰铢即可加入，各自获得签证和全部特权。",
    eligibleTitle: "支持家庭申请的会员等级",
    eligibleSubtitle: "三个会员等级支持家庭申请。每位成员享受全部特权。",
    whoTitle: "谁可以作为家庭成员加入？",
    whoItems: [
      "配偶（需提供结婚证）",
      "20岁以下子女（需提供出生证明）",
      "主申请人的父母（需提供出生证明）",
    ],
    docsTitle: "所需家庭文件",
    docsItems: [
      "每位成员的护照复印件（至少1年有效期）",
      "每位成员的证件照",
      "结婚证（配偶用）— 经官方翻译",
      "出生证明（子女/父母用）— 经官方翻译",
      "每位成员的申请表",
    ],
    benefitsTitle: "每位家庭成员获得的权益",
    benefits: [
      "个人5年可续签多次入境特权签证",
      "素万那普 Suvarnabhumi、普吉和清迈机场快速通关",
      "VIP迎宾和陪同服务",
      "专属机场贵宾室",
      "24/7会员联系中心支持",
      "90天报告协助",
      "银行开户协助",
      "所属等级的所有积分和生活方式福利",
    ],
    tiers: {
      platinum: { regularPrice: "THB 1,000,000", promoPrice: "75万泰铢", saving: "每人节省25万泰铢", note: "家庭成员每人75万泰铢（原价100万泰铢）。促销至2026年12月31日。" },
      diamond: { regularPrice: "THB 1,500,000", promoPrice: "75万泰铢", saving: "每人节省75万泰铢", note: "家庭成员每人75万泰铢（原价150万泰铢）。促销至2026年12月31日。" },
      reserve: { regularPrice: "THB 2,000,000", promoPrice: "75万泰铢", saving: "每人节省125万泰铢", note: "家庭成员每人75万泰铢（原价200万泰铢）。促销至2026年12月31日。" },
    },
    faqTitle: "家庭会员常见问题",
    faqs: [
      { q: "批准后可以添加家庭成员吗？", a: "可以，会员期间随时可以添加家庭成员。他们将获得与主会员相同等级的特权和签证期限。" },
      { q: "儿童需要自己的签证吗？", a: "是的，所有外国人无论年龄都需要有效的泰国签证。儿童将作为家庭会员的一部分获得自己的特权入境签证。" },
      { q: "孩子满20岁后怎么办？", a: "孩子满20岁后，可以按照当时的价格申请个人会员，或在家庭会员到期前继续使用。" },
      { q: "所有等级都有家庭折扣吗？", a: "仅白金（10年）、钻石（15年）和尊享（20年）提供家庭折扣。铜卡和金卡为个人会员。" },
      { q: "家庭申请需要多长时间？", a: "每位成员经历相同的审批流程（4-8周）。所有申请可同时提交。" },
    ],
    ctaTitle: "为您的家庭带来泰国精英体验",
    ctaButton: "申请家庭会员",
    ctaNote: "联系我们获取个性化家庭会员建议",
  },

  // Comparison page
  compare: {
    metaTitle: "泰国精英会员对比 – 互动指南与测试",
    metaDescription: "并排比较所有泰国精英会员等级。通过互动测试找到最适合您的方案。",
    badge: "对比指南",
    title: "比较所有会员等级",
    subtitle: "通过互动对比工具和个性化测试，找到最适合您生活方式的泰国精英会员。",
    startQuiz: "找到我的会员",
    quizTitle: "哪个会员等级适合您？",
    quizSubtitle: "回答4个简单问题，我们将为您推荐最佳等级。",
    tableTitle: "并排对比",
    tableSubtitle: "所有功能、所有等级一目了然。在手机上可横向滑动查看。",
    feature: "功能",
    price: "价格",
    quiz: {
      applicantsQ: "多少人申请？",
      just1: "只有我",
      people: "人",
      durationQ: "您计划在泰国待多久？",
      budgetQ: "每位主申请人的预算是多少？",
      prioritiesQ: "什么对您最重要？（可多选）",
      pWellness: "水疗与健康",
      pGolf: "高尔夫",
      pPoints: "特权积分",
      pFamily: "家庭选项",
      pLongterm: "长期居住",
      next: "下一步",
      back: "返回",
      seeResult: "查看推荐",
      recommendation: "我们的推荐",
      noFamily: "注意：此等级不支持家庭申请。请考虑白金或更高等级。",
      retake: "重新测试",
    },
    highlights: {
      family: "适合家庭",
      familyDesc: "白金、钻石和尊享支持家庭申请（配偶、父母、子女）：2026年12月31日前每人75万泰铢（原价100万泰铢起）。",
      duration: "5至20年",
      durationDesc: "选择适合您长期计划的会员期限。",
      value: "超高性价比",
      valueDesc: "5年仅需65万泰铢起——最实惠的长期签证方案。",
    },
  },

  // Guides page
  guides: {
    metaTitle: "泰国精英签证指南 – 签证、税务、银行与泰国生活",
    metaDescription: "泰国精英会员必备指南：停留延期、税务、银行开户、驾照、TM30、90天报告、逾期居留和居住证明。",
    badge: "会员指南",
    title: "泰国生活必备指南",
    subtitle: "泰国精英会员需要了解的一切 — 从签证延期到税务规划、银行开户、驾驶和行政要求。",
    contactUs: "需要帮助？联系我们",
    otherGuides: "其他指南",
    readMore: "阅读完整指南",
    lastUpdated: "最后更新",
    articles: {
      stayExtension: { shortTitle: "停留延期", title: "泰国精英签证持有人1年停留延期", summary: "如何在不离开泰国的情况下延长1年以上的停留。所需文件、费用和流程。", sections: [
        { heading: "了解您的入境章", content: "作为泰国精英签证（PE）持有人，您拥有5年可续签多次入境签证。每次入境泰国，移民官将给予1年停留许可。\n\n请务必检查入境章，确认其显示从入境日起1年的有效期。如显示少于1年，请立即告知移民官并出示您的签证贴纸。" },
        { heading: "何时申请延期", content: "如果您希望在不出境的情况下在泰国停留超过1年，须在当前停留许可到期前到您所在省份最近的移民局申请1年延期。\n\n可在当前停留许可到期前30天内申请。延期费用为1,900泰铢（仅限现金）。" },
        { heading: "所需文件", content: "1. 护照\n2. 护照复印件2份（首页、当前泰国精英签证页、最新入境章页）——已签名\n3. 两张2寸（4×6厘米）照片\n4. 泰国精英会员卡或确认函\n5. TM30回执\n6. TM7表格（移民局有售）\n7. 每人1,900泰铢延期费（仅限现金）" },
        { heading: "重要警告", content: "未办理延期而在入境章到期后继续停留属于逾期居留，将面临严重法律后果，包括罚款、拘留、遣返，以及最长10年的入境禁令。" },
      ] },
      taxes: { shortTitle: "税务", title: "泰国精英会员税务指南", summary: "泰国税务居民规则、外国收入、双重征税协定及关键建议。", sections: [
        { heading: "税务居民 — 180天规则", content: "根据泰国税法，在一个日历年内在泰国停留180天或以上即成为税务居民，须就来源于泰国境内的收入缴纳个人所得税。" },
        { heading: "境外来源收入", content: "自2024年1月1日起，泰国税务局更新规定：汇入泰国的境外来源收入，无论何时取得，均须纳税。\n\n但此规定仅适用于税务居民（在泰停留180天以上）。若每年在泰国停留不足180天，境外收入无需在泰纳税。" },
        { heading: "泰国精英签证与税务规划", content: "泰国精英签证（特权入境签证）被划定为旅游签证，不授予工作许可。许多会员在居住泰国的同时，在境外经营业务和管理投资。\n\n了解旅游活动与应税经济活动之间的区别对于合规至关重要。" },
        { heading: "双重征税协定（DTA）", content: "泰国已与60多个国家签署双重征税协定，可减少或消除某些类型收入的双重征税。\n\n请咨询合格的泰国税务顾问，了解您所在国与泰国的税收协定如何适用于您的具体情况。" },
        { heading: "关键建议", content: "1. 仔细记录在泰国的天数——180天是判定税务居民身份的关键门槛。\n2. 保存所有收入来源和汇款记录。\n3. 做出财务决策前咨询持牌税务顾问。\n4. 考虑收入汇款的时间安排和结构。\n5. 在适用情况下充分利用您所在国与泰国的税收协定。\n\n免责声明：本指南仅供参考。税法频繁变动，请就您的具体情况咨询专业税务人员。" },
      ] },
      bankAccount: {
        shortTitle: "银行账户",
        title: "精英会员在泰国开设银行账户",
        summary: "所需文件、合作银行、账户类型及 EPL 协助服务 — 持 Thailand Privilege Card 在泰国开设银行账户所需的全部信息。",
        sections: [
          {
            heading: "精英会员的优势",
            content: "Thailand Privilege Card 会员可通过会员联络中心获得专属银行开户协助。普通游客往往难以开设泰国银行账户，而精英会员可在合作银行享受简化的开户流程：Kasikorn Bank、Bangkok Bank、Siam Commercial Bank（SCB）和 LH Bank。",
          },
        ],
        banks: {
          heading: "各银行所需文件",
          intro: "每家合作银行均有各自的文件清单。预约前请仔细查阅对应银行的说明 — 请尽量携带原件。",
          columns: { document: "所需文件", details: "详情" },
          remarksLabel: "备注",
          items: [
            {
              name: "Kasikorn Bank",
              docs: [
                { document: "护照", details: "附有 PE 或 SE 签证的护照" },
                { document: "Thailand Privilege 会员证明", details: "Thailand Privilege Card 或确认 TPC 会员身份的证明函" },
                { document: "泰国居住证明", details: "租约、电费或水费账单" },
                { document: "政府颁发的身份证件", details: "会员本国国籍的国民身份证、驾照或户籍证明" },
              ],
            },
            {
              name: "Bangkok Bank",
              docs: [
                { document: "有效护照", details: "需提供护照原件" },
                { document: "Thailand Privilege 签证", details: "非移民签证 SE（特别入境）或 PE（特权入境）" },
                { document: "Thailand Privilege 会员卡", details: "有效的 Thailand Elite 卡" },
                { document: "泰国居住证明", details: "房产所有权文件、租约或近期水电费账单" },
                { document: "联系电话", details: "需提供泰国或可联系的电话号码" },
                { document: "本国身份证件", details: "显示本国地址的国民身份证或驾照（需提供英文版或经公证的翻译件）" },
                { document: "辅助文件", details: "一份额外的可信文件，说明开户原因" },
              ],
              remarks: [
                "不接受酒店地址和邮政信箱地址。",
                "需提供原件。",
              ],
            },
            {
              name: "Siam Commercial Bank (SCB)",
              docs: [
                { document: "护照", details: "附有有效 PE 或 SE Thailand Privilege 签证的护照" },
                { document: "Thailand Privilege 会员卡", details: "需提供会员卡" },
                { document: "证明函", details: "Thailand Elite 出具的证明函" },
                { document: "泰国地址", details: "申请表填写所需" },
                { document: "泰国手机号码", details: "网上银行所需" },
                { document: "本国身份证件", details: "驾照或国民身份证" },
              ],
            },
            {
              name: "LH Bank",
              docs: [
                { document: "护照", details: "附有精英签证贴纸的护照（目前不接受电子签证）" },
                { document: "Thailand Privilege 会员证明", details: "证明函或 TPC 会员卡" },
                { document: "本国身份证件", details: "驾照或国民身份证" },
                { document: "泰国联系电话", details: "必须提供" },
                { document: "泰国居住证明", details: "租约、租赁合同、Tabian Baan（黄/蓝本户口簿）或地契（Chanote）" },
              ],
              remarks: ["不接受酒店地址。"],
            },
          ],
        },
        accountTypes: {
          heading: "可开立的账户类型",
          columns: { type: "账户类型", details: "详情" },
          items: [
            { type: "储蓄账户", details: "起存金额 0–500 泰铢" },
            { type: "定期存款账户", details: "起存金额 1,000 泰铢" },
            { type: "泰铢及外币存款账户（FCD）", details: "可开立" },
            { type: "账户管理费", details: "无管理费" },
          ],
        },
        accountConditions: {
          heading: "账户条件",
          columns: { condition: "条件", scb: "SCB", kasikorn: "Kasikorn Bank", bangkok: "Bangkok Bank" },
          items: [
            {
              condition: "最低初始存款",
              scb: "500 泰铢",
              kasikorn: "500 泰铢",
              bangkok: "不适用",
            },
            {
              condition: "最低余额要求",
              scb: "2,000 泰铢",
              kasikorn: "2,000 泰铢",
              bangkok: "2,000 泰铢",
            },
            {
              condition: "每月管理费",
              scb: "若账户12个月内无交易且余额 ≤ 2,000 泰铢，收取 50 泰铢/月",
              kasikorn: "若账户12个月内无交易且余额 ≤ 2,000 泰铢，收取 50 泰铢/月",
              bangkok: "不适用",
            },
          ],
        },
        importantNotes: {
          heading: "重要提示",
          columns: { bank: "银行", info: "处理信息" },
          items: [
            { bank: "Kasikorn Bank", info: "审批前需7个工作日进行文件核查" },
            { bank: "Bangkok Bank", info: "审批前需7个工作日进行文件核查" },
          ],
          footer: "会员须在获批后1至15天内返回银行完成开户。如尚未收到会员卡，可使用证明函替代 — 仅限在 Kasikorn Bank 和 SCB 开立账户时适用。",
        },
        assistantService: {
          heading: "EPL 银行开户协助服务（曼谷）",
          intro: "我们的 Elite Personal Liaison（EPL）团队可亲自陪同您前往以下网点开立银行账户：",
          columns: { bank: "银行", branch: "网点" },
          items: [
            { bank: "Bangkok Bank", branch: "总行网点" },
            { bank: "Kasikorn Bank", branch: "Thanon Sathon 网点" },
            { bank: "SCB", branch: "Thanon Sathon 网点" },
            { bank: "LH Bank", branch: "Q House Lumpini" },
          ],
          remarksLabel: "备注",
          remarks: [
            "须至少提前5个工作日预约。",
            "该服务仅适用于居住在曼谷的会员。",
            "首次 EPL 协助服务免费。",
            "第二次起，收费为 3,000 泰铢或兑换2积分（适用会员）。",
          ],
        },
        faqs: {
          heading: "常见问题",
          items: [
            {
              question: "如果尚未收到会员卡，能否开设银行账户？",
              answer:
                "可以。对于已贴有精英签证的储蓄账户（泰铢或外币），可使用 Thailand Privilege 证明函代替实体会员卡。证券交易账户（股票）仍需实体会员卡。下表列出了各账户类型和银行所需的文件。",
              table: {
                columns: {
                  account: "账户类型",
                  kasikorn: "Kasikorn Bank",
                  bangkok: "Bangkok Bank",
                },
                items: [
                  {
                    account: "证券交易账户（股票）— 资金账户",
                    kasikorn: "护照 + 会员卡 + 存折或银行账册",
                    bangkok:
                      "护照 + 会员卡 + 存折或银行账册 + 税务识别号",
                  },
                  {
                    account: "储蓄账户（泰铢/外币）— 持会员卡",
                    kasikorn: "护照 + 会员卡",
                    bangkok: "护照 + 会员卡",
                  },
                  {
                    account: "储蓄账户（泰铢/外币）— 无会员卡",
                    kasikorn: "护照 + 证明函",
                    bangkok: "护照 + 证明函",
                  },
                ],
                footer:
                  "请至少提前3个工作日携带会员证明函通过会员联络中心申请服务。",
              },
            },
            {
              question: "如何在 Bangkok Bank 申请信用卡？",
              answer:
                "您须开立定期存款账户，最低存款额为 50,000 泰铢。该存款作为信用卡的担保抵押。",
            },
          ],
        },
        closing: "如需进一步协助，请随时联系我们。我们的会员联络中心全天候24/7为您服务。",
      },
      driving: { shortTitle: "驾照", title: "在泰国获取驾驶执照", summary: "如何获得泰国驾照 — 要求、流程和精英会员专属提示。", sections: [
        { heading: "国际驾照（IDP）", content: "持有本国颁发的有效国际驾照（IDP）可在泰国驾驶90天。超过90天后，应申请泰国驾照。\n\n注意：单独持有本国驾照（无IDP）在泰国不具法律效力。" },
        { heading: "泰国驾照申请要求", content: "1. 带有泰国精英签证的有效护照\n2. 大使馆或移民局出具的居住证明\n3. 健康证明（任何诊所均可，约100泰铢）\n4. 本国现行有效驾照\n5. 国际驾照（建议提供）\n6. 证件照（1寸，2张）" },
        { heading: "陆路运输厅（DLT）办理流程", content: "1. 准备所有文件，前往DLT办公室。\n2. 进行色盲和反应测试。\n3. 观看培训视频（约1小时）。\n4. 参加笔试（提供英文版）——如为外国驾照换发，可能免试。\n5. 参加驾驶测试（换发驾照可能免考）。\n6. 缴纳费用（汽车205泰铢，摩托车105泰铢）。\n7. 领取2年临时驾照。\n\n2年后可续签为5年驾照。" },
      ] },
      adminDeclarations: { shortTitle: "行政申报", title: "泰国外国人行政申报", summary: "地址登记、工作许可和官方申报等关键行政要求。", sections: [
        { heading: "地址登记（TM30）", content: "所有在泰国居住的外国人须在到达后24小时内通过TM30办理地址登记，通常由酒店、房东或房产所有者代为办理。泰国精英会员可向会员联络中心寻求协助。" },
        { heading: "税务识别号（TIN）", content: "如在泰国有收入或需要报税，须向税务局申请税务识别号。所需文件包括护照、工作许可（如适用）及地址证明。" },
        { heading: "婚姻与出生登记", content: "外国公民可在当地区公所（Amphur）登记婚姻和出生。文件须翻译成泰文并经大使馆认证。请联系您的大使馆了解具体要求。" },
        { heading: "大使馆登记", content: "建议在泰国的本国大使馆进行登记，以确保能够及时收到重要通知，并在紧急情况下获得领事服务。" },
      ] },
      tm30: {
        shortTitle: "TM30",
        title: "TM30 — 泰国外国人居住地址申报（2026年 Thailand Elite 会员指南）",
        summary: "Thailand Privilege Card 会员须知的所有 TM30 信息：谁提交、签证加注/居住证明/90天报到时何时需要 TM30，以及房东注册流程与逐步操作视频。",
        sections: [
          {
            heading: "Thailand Elite 会员 TM30 快速解答",
            content: "TM30（外国人居住通知）是您的房东、酒店或房产所有者须在您入住泰国后24小时内向移民局申报的表格。\n\n对于大多数租住公寓或入住酒店的 Thailand Elite / Thailand Privilege 会员，房东或前台会代为办理申报 — 您只需保存好 TM30 回执即可。若您自己拥有房产，则须在官方 TM30 门户注册并自行提交申报。\n\n您在以下情况需要有效的 TM30 回执：\n• 在 Chaeng Wattana 移民局加注 Thailand Privilege 签证贴纸\n• 申请居住证明\n• 提交90天报到（TM47）— TM30 上的地址须与报到地址一致\n• 申请年度居留延期或重入境许可\n\n实际操作中，每个地址每年通常只需申报一次 TM30 — 前提是您未出境或未更换地址。",
          },
          {
            heading: "什么是 TM30？",
            content: "TM30 是根据泰国《移民法》佛历2522年（1979年）第38条规定的法定申报表格，用于向移民局申报每位外国人在泰国的当前居住地址。\n\n申报义务由房产所有者或「户主」承担，而非外国人本人。实际操作中，Thailand Elite 会员通常需要确认房东确实已经提交，因为 TM30 回执是几乎所有其他移民手续的前提文件（签证加注、居住证明、90天报到、居留延期）。",
          },
          {
            heading: "泰国谁必须提交 TM30？",
            content: "依法，义务由房产所有者或「户主」承担，而非外国人。适用情况如下：\n\n• 酒店和服务式公寓 — 入住时自动办理。离店前务必向前台索取 TM30 回执。\n• 房东（公寓或房屋租赁）— 您的房东须在您入住后24小时内提交。请坚持索取 PDF 回执。\n• 房产所有者 — 若您自己拥有所住的公寓、别墅或住宅，须在 TM30 门户注册并自行提交申报。\n• 接待外国人的亲友 — 即使无偿接待，房主依法也须为任何在此过夜的非泰国籍访客提交 TM30。\n\n若房产在未提交有效 TM30 的情况下接待外国人，房主最高可被罚款 10,000 泰铢。外国人因未确保申报已完成，也可被罚款最高 2,000 泰铢。",
          },
          {
            heading: "如何注册 TM30（房东及 Thailand Elite 自住业主）",
            content: "若您在泰国拥有自住房产，须先创建 TM30 门户账户方可提交申报。注册全程在线完成，约需10分钟。\n\n官方门户：\nhttps://tm30.immigration.go.th/tm30//#/external/security/register\n\n逐步操作视频教程：\nhttps://youtu.be/fqZd7B1ub5A\n\n注册所需材料：\n• 附有有效 Thailand Privilege 签证（PE 或 SE）的护照\n• 所有权证明 — Chanote（地契）、公寓产权证或房屋户籍证明（Tabian Baan）\n• 接收 OTP 的泰国手机号码\n• 有效电子邮件地址\n\n审批通常需要1至2个工作日。账户激活后，每当外国人 — 包括您本人 — 入住或重新入住该房产时，即可提交 TM30。",
          },
          {
            heading: "如何为外国人提交 TM30",
            content: "房东账户激活后，提交 TM30 非常简便：\n\n1. 登录 TM30 门户。\n2. 点击「申报外国人居住」，输入访客护照信息：护照号、国籍、抵达日期、预计离开日期。\n3. 确认地址 — 须与您账户中登记的房产地址一致。\n4. 提交。系统生成附有参考编号的 PDF 回执。\n5. 保存 PDF 并将副本转发给外国人 — 他们办理所有后续移民手续时均需用到。\n\n每次外国人重新入境泰国，即使回到同一地址，也须重新提交 TM30。24小时计时在每次重新入境时重置，而非从最初签租约之日起算。",
          },
          {
            heading: "Thailand Elite / Privilege 会员何时需要 TM30？",
            content: "TM30 是精英会员与泰国移民局几乎所有交涉的必备前提文件。以下情况均需有效、最新的 TM30 回执：\n\n• 加注 Thailand Privilege 签证 — 在曼谷政府中心 Chaeng Wattana 移民局第一处办理，移民官在签发签证贴纸前会要求查看 TM30 回执。\n• 申请居住证明 — 移民局要求提交当前 TM30 方可出具证明，该证明用于办理驾照、购买车辆和公寓、银行开户等。详见我们的居住证明指南。\n• 提交90天报到（TM47）— 90天报到上的地址须与最新 TM30 上的地址一致。这是在线 TM47 提交被拒的最常见原因。\n• 申请年度居留延期或重入境许可。\n\n若您全年在同一登记地址居住且未出境，通常一次 TM30 即可。实际上，大多数精英会员每年在国际旅行后会重新申报一至两次。",
          },
          {
            heading: "90天报到被拒的原因及 TM30 解决方案",
            content: "若您的在线 TM47 90天报到持续被拒，最可能的原因是 TM30 地址不一致：\n\n• 您曾前往其他府旅行（如清迈或普吉的酒店）。\n• 该酒店提交了一份以其地址作为您最新注册居所的 TM30。\n• 当您尝试从曼谷家庭住址提交90天报到时，系统因两个地址不符而拒绝。\n\n解决方法：请您在曼谷的房东 — 或您本人（若为自住业主）— 以您的返回日期重新提交一份 TM30。一旦最新 TM30 与90天报到上的地址一致，TM47 即可在线成功提交。\n\n若房东未及时响应，Thailand Elite 会员联络中心可协助协调重新申报。",
          },
          {
            heading: "TM30 违规处罚",
            content: "• 房产所有者/房东 — 最高罚款 10,000 泰铢。\n• 外国人（因未确保申报已完成）— 最高罚款 2,000 泰铢。\n• 实际后果 — 未持有有效 TM30，您将无法提交90天报到、加注精英签证、申请居住证明或办理居留延期。移民局工作人员将拒绝办理，直至申报记录已录入系统。\n\n建议在手机上专设一个文件夹，保存每份 TM30 的 PDF 回执 — 您被要求出示的频率可能超出预期。",
          },
        ],
        faqs: {
          heading: "TM30 — 常见问题",
          items: [
            {
              question: "泰国谁须提交 TM30？",
              answer:
                "依法，房产所有者、房东、酒店或「户主」负责提交 TM30，而非外国人本人。酒店在入住时自动办理。房东须在您抵达后24小时内提交。若您在泰国自住，须在 TM30 门户注册并自行提交。",
            },
            {
              question: "作为房产所有者，如何注册 TM30？",
              answer:
                "请在官方门户 https://tm30.immigration.go.th/tm30//#/external/security/register 创建账户。您需要附有有效 Thailand Privilege 签证的护照、所有权证明（Chanote、公寓产权证或 Tabian Baan）、接收 OTP 的泰国手机号码以及电子邮件地址。审批通常需要1至2个工作日。逐步操作视频可在 https://youtu.be/fqZd7B1ub5A 查看。",
            },
            {
              question: "Thailand Elite / Thailand Privilege 会员何时需要 TM30 回执？",
              answer:
                "您需要有效的 TM30 回执方可在 Chaeng Wattana 移民局加注 Thailand Privilege 签证、申请居住证明、提交90天 TM47 报到，以及申请年度居留延期或重入境许可。",
            },
            {
              question: "为什么我的90天报到（TM47）一直在线被拒？",
              answer:
                "最常见原因是 TM30 地址不一致：若您旅行期间其他府的酒店提交了以其地址为您最新注册居所的 TM30，该地址与您家庭住址不符，90天报到将被拒绝。请让您的家庭房东（或您本人，若为自住业主）以您的返回日期重新提交一份 TM30 — 地址一致后，TM47 提交即可成功。",
            },
            {
              question: "Thailand Elite 会员需要多久提交一次 TM30？",
              answer:
                "依法，每次抵达或重新入住该房产后24小时内须提交 TM30。实际上，若您全年在同一地址居住且未出境，一次 TM30 即可。大多数精英会员每年在国际旅行后会重新申报一至两次。",
            },
            {
              question: "若房东拒绝或忘记提交 TM30 怎么办？",
              answer:
                "房东依法最高可被罚款 10,000 泰铢，您也可能因未确保申报完成而被罚款最高 2,000 泰铢。更重要的是，您将无法提交90天报到、加注精英签证或申请居住证明。请联系 Thailand Elite 会员联络中心 — 他们可协助督促房东或安排替代方案。",
            },
          ],
        },
        videoUrl: "https://youtu.be/fqZd7B1ub5A",
        videoTitle: "如何在 TM30 门户注册 — 逐步操作（Thailand Elite 会员）",
        registerUrl: "https://tm30.immigration.go.th/tm30//#/external/security/register",
        labels: {
          watchVideo: "观看注册操作视频",
          openPortal: "打开官方 TM30 门户",
          relatedHeading: "相关指南",
          residenceCertLink: "在泰国申请居住证明",
        },
      },
      annualExtension: { shortTitle: "年度延期", title: "泰国精英会员年度签证延期", summary: "如何在不离开泰国的情况下每年更新停留许可。", sections: [
        { heading: "为什么需要年度延期", content: "即使您的泰国精英签证有效期为5至20年（因等级而异），每次入境所授予的最长停留许可为1年。若您连续在泰国停留超过1年，须申请年度延期。" },
        { heading: "何时申请", content: "可在当前停留许可到期前30天内申请年度延期。我们强烈建议至少提前2周申请，以避免任何意外情况。\n\n请勿等到最后一天——移民局可能较为繁忙，延误可能导致逾期居留。" },
        { heading: "办理流程", content: "1. 准备所有所需文件（与停留延期指南相同）。\n2. 前往您登记地址所在省份最近的移民局。\n3. 提交TM7表格及相关文件。\n4. 缴纳1,900泰铢现金。\n5. 拍照并采集指纹。\n6. 获得新的1年延期章。\n\n延期起始日期从当前到期日起算，而非申请当日。" },
      ] },
      ninetyDays: {
        shortTitle: "90天报告",
        title: "TM47表格 — 泰国90天报告（2026年 Thailand Elite 会员指南）",
        summary: "Thailand Elite / Thailand Privilege 会员关于 TM47 表格及泰国90天报告的完整须知：TM47 是什么、如何填写、如何在线申报、亲自办理、邮寄申报，或通过曼谷、芭提雅、普吉岛和清迈的 Elite 代办服务提交——以及罚款规定和 TM47 被拒后的处理方法。",
        sections: [
          {
            heading: "TM47 表格 / 90天报告 — Thailand Elite 会员快速解答",
            content: "TM47 是泰国官方移民表格，所有在泰国连续停留90天或以上的外国人均须填报，以确认当前居住地址。TM47 表格不延长签证有效期，仅为例行地址核查，所有长期居留者（包括 Thailand Elite / Thailand Privilege 会员）均须遵守。\n\n您可通过以下四种方式提交 TM47：\n• 通过官方门户网站在线申报——免费，可在到期日前15天至到期日后7天内办理\n• 亲自前往管辖您登记地址的移民局办理（现场提供 TM47 纸质表格）\n• 以挂号信方式邮寄（纸质 TM47 表格须至少提前15天寄出）\n• 通过 Thailand Elite 在曼谷、芭提雅、普吉岛和清迈的代办服务——由我们的团队代您向移民局提交 TM47 表格\n\n每次出境并重新入境泰国后，90天计数器将重置，因此如有国际出行，大多数会员每年仅需申报一至两次。逾期申报将被处以 THB 2,000 罚款；完全未申报最高可被处以 THB 5,000 罚款，并可能在下次移民局预约时产生麻烦。",
          },
          {
            heading: "什么是 TM47 90天报告？",
            content: "TM47 是根据《泰国移民法》佛历2522年（1979年）第37条第（5）款规定的法定申报文件。每位在泰国连续停留90天或以上的外国人，均须向移民局报告当前居住地址，并在继续居留期间每90天重复申报一次。\n\nTM47 与签证到期日无关，不延长停留许可，纯属行政性地址确认手续，与 TM30（您入住时由房东申报）不同。两者区别请参阅我们的 TM30 指南。",
          },
          {
            heading: "哪些人需要填报 TM47？",
            content: "所有持长期签证在泰国停留、且连续居留超过90天的外国人，均须填报 TM47。具体包括：\n\n• Thailand Elite / Thailand Privilege 签证持有人（PE 和 SE）\n• 退休签证持有人（Non-OA / Non-OX）\n• 婚姻签证持有人（Non-O）\n• 工作许可持有人（Non-B）\n• 教育签证持有人（Non-ED）\n• 长期居留（LTR）签证持有人\n\n游客和短期访客通常无需填报 TM47，因其许可停留期很少达到连续90天。如因任何原因（即便是短暂周末出行）离开泰国，计数器将重置，重新入境后开始新的90天计时。",
          },
          {
            heading: "90天报告的申报期限是何时？",
            content: "首次 TM47 须于连续停留第90天申报，此后每90天循环申报一次。移民局设有灵活的申报窗口期：\n\n• 最早可申报时间：到期日前15天\n• 最晚可申报时间：到期日后7天（无罚款）\n• 超过第7天后：须缴纳 THB 2,000 罚款，并在下次延期或签证加签预约时产生实际影响\n\n如离境并重新入境泰国，90天计时器以新入境日期重新计算，无需为任何时长的出行单独申报 TM47，仅连续停留达90天或以上时方须申报。\n\nThailand Elite 会员可联系 Member Contact Center 跟踪到期日并接收提醒。对于使用礼宾服务的会员，我们也会自动提供此项服务。",
          },
          {
            heading: "如何在线填写并提交 TM47 表格",
            content: "在线申报免费、全天候可用，现已成为居住在曼谷或偏远省份的 Thailand Elite 会员最常用的方式。官方 TM47 在线门户由泰国移民局运营：\n\n官方 TM47 在线门户：https://tm47.immigration.go.th/tm47/\n\n在线填写 TM47 表格所需信息：\n• 护照号码及与护照资料页完全一致的个人信息\n• 最新签证入境日期（查看最近一次入境章）\n• 泰国现住址——须与最新 TM30 登记地址一致\n• 有效电子邮箱地址（系统将以 PDF 格式发送回执）\n• 可选：上次90天报告回执（供参考）\n\n在线填写 TM47 的分步操作流程：\n1. 打开门户网站并登录（首次使用者需以护照及电子邮箱注册）。\n2. 确认个人信息——姓名、国籍、护照号码、出生日期。\n3. 输入签证信息及最新入境日期。\n4. 输入在泰国的现住址（须与 TM30 完全一致——街道、行政区、邮政编码）。\n5. 仔细核查每个字段。拼写错误或地址不匹配是被拒的最常见原因。\n6. 确认并提交。\n7. 下载 PDF 回执——保存至手机专用文件夹。在下次签证加签、居住证明或延期预约时，您将被要求出示此回执。\n\n处理通常即时完成。如门户返回错误，请参阅下一节。",
          },
          {
            heading: "TM47 在线申报被拒的原因及解决方法",
            content: "在线 TM47 被拒最常见的原因是 TM30 地址不匹配。门户会将您输入的地址与您最新的 TM30（由房东申报的地址通知）进行交叉核验。若两者不完全一致，系统将返回错误。\n\n典型情形：\n• 您前往另一省份旅行，酒店为您申报了 TM30——该酒店地址现已成为您的最新登记居住地，与您的家庭住址不符。\n• 您最近重新入境泰国后，房东忘记重新申报 TM30。\n• 您已搬家，新地址尚未完成申报。\n\n每种情况的解决方法均相同：确保您申报地址处存有当前有效的 TM30。请您的房东（或您本人，如您是房产所有人）重新提交 TM30——待其进入系统后，您的 TM47 在线申报即可顺利通过。TM30 登记步骤请参阅我们的 TM30 指南。\n\n如 TM30 更正后门户仍无法提交，Member Contact Center 可协助安排在移民局人工办理，对首次申报的会员尤为有用。",
          },
          {
            heading: "亲自前往或邮寄提交 TM47",
            content: "如您偏好线下申报，可选择以下两种方式：\n\n亲自前往——前往管辖您登记地址的移民局。请携带：护照（原件及资料页、签证页、最新入境章的复印件）、最新 TM30 回执、已填写的 TM47 表格（可在现场领取），以及上次90天报告回执（如有）。部分办事处接受直接排队；业务繁忙的办事处（如曼谷 Chaeng Wattana）建议上午前往。\n\n邮寄——下载 TM47 表格并填写完毕，附上护照页复印件及 TM30 回执，以挂号信方式寄往管辖您地址的移民局。请附上贴好邮票的回邮信封，以便对方寄回盖章回执。邮寄件须至少提前15天到达移民局——请仔细跟踪快递，因为邮戳日期以到达为准。\n\n实际操作中，Thailand Elite 会员很少使用邮寄方式，在线门户或 Elite 代办服务更为快捷方便。",
          },
          {
            heading: "Thailand Elite 代办服务 — Bangkok、Pattaya、Phuket、Chiang Mai",
            content: "Thailand Elite 会员可将90天报告交由我们的团队代为向移民局提交。我们在四个城市每周定期提供代办服务。请将您的护照（或复印件）及最新 TM30 回执带至相应地点，您将在1至2个工作日内收到盖章的 TM47 回执。\n\n无需收费，无需排队，无需应对门户报错的烦恼。预约须通过 Member Contact Center 至少提前24小时办理。当前服务日期、地址及时间请参见下方表格。",
          },
          {
            heading: "TM47 逾期或漏报处罚",
            content: "• 逾期申报（到期日后超过7天）：在下次移民局预约时缴纳 THB 2,000 罚款。\n• 被查获从未申报（例如在机场出境时或办理延期时）：罚款最高可达 THB 5,000。\n• 多次不合规可能影响未来签证延期、重新入境许可及居住证明申请。\n\n漏报 TM47 不会产生犯罪记录，也不会导致签证注销——但移民官员会予以记录，且罚款须以现金缴清后方可为您办理其他任何手续。请在每次连续停留第75天设置日历提醒，或交由 Member Contact Center 为您追踪。",
          },
        ],
        faqs: {
          heading: "TM47 表格 / 90天报告 — 常见问题解答",
          items: [
            {
              question: "泰国的 TM47 是什么？",
              answer: "TM47 是用于90天报告的泰国官方移民表格。每位在泰国连续停留90天或以上的外国人，均须填写 TM47 以向移民局确认当前地址，此后每90天重复申报一次。TM47 适用于所有长期签证类型，包括 Thailand Elite / Thailand Privilege 签证、退休签证、婚姻签证、工作签证、教育签证及 LTR 签证。",
            },
            {
              question: "TM47 表格是什么？",
              answer: "TM47 表格（《在泰王国停留逾90天申报表》）是外国人向泰国移民局申报地址的文件。该表格以纸质形式在每个移民局办事处免费提供，也可通过官方门户 https://tm47.immigration.go.th/tm47/ 以电子形式填写。TM47 表格不延长签证有效期，纯属地址核查；提交后，您将收到一份盖章回执，请随护照一并保管。",
            },
            {
              question: "如何填写 TM47 表格？",
              answer: "在纸质 TM47 表格上，需填写：您的全名、国籍及护照号码；最近一次入境泰国的日期及签证类别（Thailand Elite 会员填写 Privilege Entry Visa）；您在泰国的现住址（须与最新 TM30 一致）；您的电话号码及签名。通过官方门户在线申报时，系统将尽量从上次申报记录中预填相同字段。请务必仔细核查地址——与 TM30 不符是 TM47 被拒的最常见原因。完整在线操作流程请参阅上方分步说明。",
            },
            {
              question: "在哪里可以下载 TM47 表格？",
              answer: "纸质 TM47 表格在每个泰国移民局办事处均可免费领取，无需提前下载或打印。如需邮寄申报，也可从移民局官网（https://www.immigration.go.th）下载。在线申报请使用官方 TM47 门户 https://tm47.immigration.go.th/tm47/——该流程无需下载 PDF。",
            },
            {
              question: "什么是 TM47 90天报告？",
              answer: "TM47 90天报告即本指南全程提及的《在泰王国停留逾90天申报表》。根据《泰国移民法》第37条第（5）款规定，所有长期签证持有人（包括 Thailand Elite / Thailand Privilege 会员）均须遵守。该报告不延长签证有效期，纯属地址核查手续。",
            },
            {
              question: "如何在线申报 TM47？",
              answer: "前往官方 TM47 在线门户 https://tm47.immigration.go.th/tm47/，以护照及电子邮箱注册，确认地址（须与最新 TM30 一致）并提交。处理通常即时完成，您可下载 PDF 回执保存至手机。在线申报免费，可在到期日前15天至到期日后7天内办理。",
            },
            {
              question: "为什么我的 TM47 在线申报被拒？",
              answer: "最常见的原因是 TM30 地址不匹配——例如，您近期出行时另一省份的酒店为您申报了 TM30，导致该酒店地址成为您的最新登记居住地。请让您的家庭房东（或您本人，如您是房产所有人）重新在家庭住址申报 TM30，然后重试 TM47 申报。具体操作步骤请参阅我们的 TM30 指南。",
            },
            {
              question: "Thailand Elite / Thailand Privilege 会员需要申报 TM47 吗？",
              answer: "需要。TM47 适用于所有在泰国连续停留90天或以上的外国人，无论签证类型。Thailand Elite 会员可享受礼宾支持，包括在 Bangkok、Pattaya、Phuket 和 Chiang Mai 的代办服务，由我们的团队代您提交报告。",
            },
            {
              question: "如果我在90天到期前离开泰国会怎样？",
              answer: "每次出境并重新入境泰国后，90天计数器将重置。如您短暂出境，无需为该次停留申报 TM47——下次入境后将开始新的90天计时。大多数有国际出行的 Thailand Elite 会员每年仅需申报一至两次。",
            },
            {
              question: "TM47 逾期申报的罚款是多少？",
              answer: "到期日后超过7天申报者，罚款 THB 2,000。如被查获从未申报（例如在机场或办理延期时），罚款最高可达 THB 5,000。罚款须在移民局以现金缴清后，方可为您办理其他任何手续。",
            },
            {
              question: "我可以提前申报 TM47 吗？",
              answer: "可以。申报窗口在正式到期日前15天开放，您可提前申报且不受处罚。许多 Thailand Elite 会员会在窗口开放后尽早申报，以便从待办事项中提前清除，并在即将出行前备好回执。",
            },
            {
              question: "申报 TM47 需要哪些信息？",
              answer: "您的护照信息、最近一次签证入境日期、在泰国的现住址（须与最新 TM30 一致），以及用于接收 PDF 回执的有效电子邮箱地址。如有上次90天报告回执，请备在手边供参考。TM6 出境卡号已不再需要（已暂缓执行）。",
            },
          ],
        },
        onlineUrl: "https://tm47.immigration.go.th/tm47/",
        labels: {
          openOnlinePortal: "打开官方 TM47 门户",
          eplHeading: "Thailand Elite 代办服务",
          eplIntro: "将您的护照复印件及最新 TM30 回执交给我们在以下任一城市的团队，我们将代您向移民局提交 TM47。须通过 Member Contact Center 至少提前24小时预约。",
          eplColumns: {
            city: "城市",
            address: "办公室 / 代办地点",
            schedule: "服务时间",
          },
          methodsHeading: "TM47 申报方式对比",
          methodsColumns: {
            method: "方式",
            timing: "处理时效",
            availability: "适用情形",
          },
          relatedHeading: "相关指南",
          tm30Link: "TM30 — 外国人地址申报",
          annualExtensionLink: "年度停留延期",
          residenceCertLink: "申请居住证明",
        },
        eplLocations: [
          {
            city: "Bangkok",
            address: "Thailand Elite 总部，Sathorn Road",
            schedule: "每周二，16:30 前",
          },
          {
            city: "Pattaya",
            address: "Thailand Elite Pattaya 区域办公室",
            schedule: "预约制（周一至周五）",
          },
          {
            city: "Phuket",
            address: "Thailand Elite Phuket 区域办公室",
            schedule: "预约制（周一至周五）",
          },
          {
            city: "Chiang Mai",
            address: "Thailand Elite Chiang Mai 区域办公室",
            schedule: "预约制（周一至周五）",
          },
        ],
        methods: [
          {
            method: "在线申报（TM47 门户）",
            timing: "即时",
            availability: "最快方式——前提是 TM30 为最新状态",
          },
          {
            method: "Thailand Elite 代办",
            timing: "1–2 个工作日",
            availability: "Bangkok、Pattaya、Phuket、Chiang Mai 的会员",
          },
          {
            method: "亲自前往移民局",
            timing: "当天",
            availability: "所有人均适用——尤其适合门户被拒时",
          },
          {
            method: "挂号信邮寄",
            timing: "须至少提前15天到达",
            availability: "偏远地区且无法使用门户的会员",
          },
        ],
      },
      overstays: { shortTitle: "逾期居留", title: "入境规定与逾期居留后果", summary: "了解逾期居留处罚、入境规定及如何保持合规。", sections: [
        { heading: "入境规定", content: "泰国精英会员可从任何国际入境口岸进入泰国。抵达时，出示带有泰国精英签证贴纸的护照，即可获得1年停留许可章。\n\n在会员期间，您可以无限次自由出入泰国（多次入境特权）。" },
        { heading: "逾期居留处罚", content: "在泰国逾期停留是严重违规行为：\n\n• 每天罚款500泰铢（最高20,000泰铢）。\n• 逾期超过90天：禁止入境1年。\n• 逾期超过1年：禁止入境3年。\n• 逾期超过3年：禁止入境5年。\n• 逾期超过5年：禁止入境10年。\n\n如因逾期居留被捕，可能面临拘留和驱逐出境，并在上述禁令基础上再加5年禁令。" },
        { heading: "如何避免逾期居留", content: "1. 始终检查入境章上正确的到期日期。\n2. 在到期日前45天设置日历提醒。\n3. 在停留许可到期前申请1年延期。\n4. 如有疑问，联系泰国精英会员联络中心。\n5. 如无法延期，在停留许可到期前离境并重新入境，即可获得新的1年停留许可章。" },
      ] },
      residenceCert: {
        shortTitle: "居住证明",
        title: "在泰国申请居住证明",
        summary: "如何向移民局申请官方居住证明 — 办理驾照、银行开户等手续所需。",
        sections: [
          {
            heading: "泰国居住证明 — 快速解答",
            content: "居住证明是泰国移民局出具的官方信函，确认您在泰国的当前注册地址。费用为 500 泰铢，获取时间为一至三个工作日，部分办公室可当日办结。任何在泰国合法居住的外国人在开设银行账户、申领泰国驾照、登记车辆或购置房产时均需提供。该文件通常称为居住证明书，是泰国机构接受的标准外国人住址证明文件。",
          },
          {
            heading: "什么是居住证明？",
            content: "居住证明（也称为居住证明书或地址证明函）是由泰国移民局出具的官方文件，确认您在泰国的当前注册地址。\n\n重要区别 — 居住证明与居留许可不同。居留许可（或永久居留权）是另一种极难获得的移民身份，授予在泰国无限期居住的权利。居住证明仅是一份地址证明函，不赋予任何移民身份或居留权利。一般旅游签证或免签入境者通常无资格申请 — 证明仅向持有有效长期签证且已在该地址登记 TM30 的外国人签发。",
          },
          {
            heading: "谁可以申请居住证明？",
            content: "任何持有效长期签证在泰国合法居住的外国人，且已在相关地址登记当前 TM30（地址申报），均可申请居住证明。符合条件的签证类别包括：\n\n• Thailand Elite / Thailand Privilege 会员（PE 或 SE 签证）\n• 退休签证持有人（Non-OA / Non-OX）\n• 婚姻签证持有人（Non-O）\n• 工作许可持有人（Non-B）\n• 教育签证持有人（Non-ED）\n• 长期居留（LTR）签证持有人\n\n持旅游签证或免签入境的游客通常无资格申请，因为移民局要求证明稳定的较长期居留。",
          },
          {
            heading: "何时需要居住证明？",
            content: "泰国银行、政府部门和房产登记处将居住证明作为外国人的标准住址证明。常见需要居住证明的情况：\n\n• 开设泰国银行账户 — 大多数主要银行（Bangkok Bank、Kasikorn、SCB）要求外国人提供。详见我们的银行开户指南。\n• 在陆路运输厅（DLT）申领泰国驾照 — 须与护照和体检证明一并提供。详见我们的驾照指南。\n• 以本人名义在运输登记处购买或登记汽车或摩托车。\n• 在土地厅购买公寓或登记长期租约。\n• 通过泰国海关从境外进口个人车辆。\n• 在区公所（Amphoe）办理婚姻或离婚登记、子女学籍登记或改名手续。\n• 开立某些需要经核实泰国地址证明的人寿保险或投资账户。",
          },
          {
            heading: "在哪里申请居住证明",
            content: "居住证明由泰国移民局签发。在曼谷，主要办理地点为：\n\n移民局第一处，政府中心B楼，Chaeng Wattana 路，曼谷 10210\n（周一至周五 08:30–16:30，公众假日休息）\n\n曼谷以外地区，可前往您所在省份的移民局办理 — 即您 TM30 登记的移民局。\n\n注意：部分外国大使馆会为本国公民出具类似居住证明的信函（有时称为居住证明书）。虽可用于与本国当局的往来，但这种大使馆信函通常不被泰国银行、陆路运输厅或房产登记处接受以替代泰国移民局出具的居住证明。",
          },
          {
            heading: "申请流程 — 逐步说明",
            content: "1. 确认您的 TM30 为最新状态 — 移民局将核查您的地址申报是否已在案且为最新。若缺失或过期，请先提交新的 TM30（参见我们的 TM30 指南）。\n2. 准备所需文件（见下一节）。\n3. 在工作时间前往移民局：周一至周五 08:30–16:30，午休时间 12:00–13:00。建议提早到达 — Chaeng Wattana 排队可能较长。\n4. 在咨询台领取并填写申请表（表格现场提供，无需自带）。\n5. 在相关窗口提交文件。\n6. 缴纳 500 泰铢费用（现金，大多数办公室不接受刷卡）。\n7. 领取证明 — 部分办公室当日即可取件，其他需一至三个工作日。提交时向工作人员确认具体领取方式。\n\n证明通常自签发之日起有效30天，部分机构（尤其是银行）可能接受90天内签发的证明 — 请在前往移民局前提前与接受方确认。",
          },
          {
            heading: "所需文件",
            content: "请携带以下所有文件的原件及复印件：\n\n• 附有有效 Thailand Privilege 签证（PE 或 SE 章）的护照 — 复印资料页、签证页及最新入境章\n• TM30 回执 — 您所申报地址的最新一份\n• 地址证明 — 以下任一文件：签署的租赁合同、近期水费或电费账单（您本人或房东名下，附租约）、Tabian Baan（房屋户籍证明）或公寓所有权证明（Chanote）\n• 两张证件照（4×6厘米）\n• 填写完整的申请表 — 移民局现场提供\n• 500 泰铢现金政府费用",
          },
          {
            heading: "Thailand Elite / Thailand Privilege 会员专属提示",
            content: "Thailand Elite 会员可通过会员联络中心（MCC）获得居住证明办理协助。MCC 可协助您准备正确文件，并在部分情况下预约 Chaeng Wattana 办理时段，减少等候时间。\n\nElite Personal Liaison（EPL）服务可陪同会员直接前往政府中心 Chaeng Wattana 移民局第一处，全程引导您经历各个窗口，并在提交前确认文件齐全。对于首次申请居住证明或不确定哪些住址证明文件会被接受的会员，此服务尤为实用。",
          },
        ],
        faqs: {
          heading: "泰国居住证明 — 常见问题",
          items: [
            {
              question: "泰国居住证明是什么？",
              answer: "居住证明是由泰国移民局出具的官方信函，确认您在泰国的当前注册地址。有时也称为居住证明书或地址证明函。它不是移民身份文件 — 仅证明您的居住地址，银行、陆路运输厅和房产登记处在处理外国人事务时会要求提供。",
            },
            {
              question: "谁可以申请居住证明？",
              answer: "任何持有效长期签证的外国人 — 包括 Thailand Elite / Thailand Privilege 会员、退休签证持有人、婚姻签证持有人、工作许可持有人、教育签证持有人和 LTR 签证持有人 — 只要已登记当前 TM30，均可申请。持旅游签证或免签入境的游客通常无资格申请。",
            },
            {
              question: "曼谷在哪里申请居住证明？",
              answer: "在曼谷，请前往移民局第一处，位于政府中心B楼，Chaeng Wattana 路，曼谷 10210。曼谷以外地区，请前往当地省级移民局办理。办理时间为周一至周五 08:30 至 16:30，公众假日休息。",
            },
            {
              question: "居住证明的费用是多少？",
              answer: "政府收费为 500 泰铢，在移民局以现金缴纳。大多数办公室不接受信用卡或借记卡，请携带足额现金或小面额钞票。",
            },
            {
              question: "申请居住证明需要多长时间？",
              answer: "处理时间因办公室和当天情况而异。部分移民局若您较早到达可当日出件，其他需一至三个工作日。提交文件时向窗口工作人员询问，因政策可能有所变化。",
            },
            {
              question: "泰国居住证明的有效期是多长？",
              answer: "证明通常自签发之日起有效30天。部分机构（如银行）可能接受90天内签发的证明 — 在前往移民局前务必向接受方确认其接受时效。",
            },
            {
              question: "居住证明与居留许可有何区别？",
              answer: "两者是完全不同的文件。居住证明是移民局应要求出具的简单地址证明函，费用 500 泰铢，数日内即可办结。居留许可（泰国永久居留权）是一种长期移民身份，允许无限期在泰国居住 — 受配额限制，需多年签证历史，涉及多阶段申请流程。大多数长期居住的外国人（包括 Thailand Elite 会员）只需要居住证明即可。",
            },
            {
              question: "申请居住证明需要 TM30 吗？",
              answer: "是的。移民局要求在您所申报地址登记有当前有效的 TM30。若缺失或过期，请先提交新的 TM30（参见我们的 TM30 指南）。否则申请将被拒绝。",
            },
            {
              question: "Thailand Elite 会员可以免排队吗？",
              answer: "Thailand Elite 会员可通过会员联络中心（MCC）提前准备文件，部分情况下可预约办理时段，减少等候时间。Elite Personal Liaison（EPL）也可陪同会员前往 Chaeng Wattana 办公室并全程引导，使整个体验比自行前往快捷便利得多。",
            },
          ],
        },
        labels: {
          relatedHeading: "相关指南",
          bankAccountLink: "开设泰国银行账户",
          drivingLink: "申领泰国驾驶执照",
          tm30Link: "TM30 — 外国人居住地址申报",
          mccTitle: "需要协助？使用会员联络中心。",
          mccDesc: "Thailand Elite / Thailand Privilege 会员可通过世界级会员礼宾服务（MCC）获得居住证明、银行开户、驾照办理及所有其他行政手续的全天候24/7协助。",
          ctaTitle: "在泰国取得合法居留身份",
          ctaDesc: "加入泰国唯一的长期会员制居留项目，获得5至20年 Thailand Privilege 签证及礼宾支持服务。",
          ctaButton: "立即申请 Thailand Elite",
        },
      },
      tdac: { shortTitle: "TDAC", title: "泰国数字入境卡（TDAC）：完整指南", summary: "如何在出行前提交泰国数字入境卡（TDAC），包括填写时间、所需信息以及给 Thailand Elite 会员的建议。", sections: [
        { heading: "什么是 TDAC？", content: "泰国数字入境卡（Thailand Digital Arrival Card，TDAC）是入境泰国前需在线填写的入境表格。它取代了以往的纸质入境卡，便于移民部门提前登记旅客及行程信息。" },
        { heading: "谁需要提交？", content: "大多数入境泰国的外国旅客都应在抵达前填写 TDAC，Thailand Elite 会员也不例外。请将确认信息的副本与旅行证件一同保存，以备航空公司或移民官查验。" },
        { heading: "何时填写 TDAC", content: "请在飞往泰国的航班之前填写 TDAC，并在提交前仔细核对护照号码、抵达日期、航班号、住宿地址及联系方式。" },
        { heading: "需要准备的信息", content: "请准备护照、航班信息、抵达日期、在泰国的住宿地址、电话或电子邮箱联系方式，以及基本的旅行历史信息。请使用与旅行证件一致的拼写和护照号码。" },
        { heading: "给 Thailand Elite 会员的建议", content: "若您使用机场快速通道或抵达接待服务，请在出发前填写 TDAC，以确保入境流程顺畅。请将确认信息保存为截图和 PDF；如临近出发时行程信息有变，请联系我们的团队。" },
      ] },
      visaAffixation: { shortTitle: "签证加注", title: "泰国精英签证加注与新护照流程", summary: "签证加注的最新规定，包括入籍申请人、所需文件、30天期限以及将签证转移至新护照的流程。", sections: [
        { heading: "最新规定概述", content: "泰国特权卡（Thailand Privilege Card）已更新会员申请审核及签证加注流程。现将申请人区分为一般申请人与入籍申请人两类。该规定即日起生效，直至另行通知。\n\n一般申请人指自出生起仅持有一种国籍、无入籍记录者。入籍申请人指取得新国家国籍（取代或额外于原国籍）者。" },
        { heading: "一般申请人", content: "一般申请人仍按标准会员申请流程办理。移民局批核时间通常为4至6周。\n\n一般申请人的签证加注无正式截止期限，但仍强烈建议尽早完成加注，以避免日后出现旅行或身份问题。" },
        { heading: "入籍申请人：需补充文件", content: "入籍申请人须在会员申请及签证加注审核中提交以下补充文件：\n\n1. 原国籍护照，若姓名变更须一并提供旧护照\n2. 原国籍放弃证明（如适用）\n3. 会员申请所用资金的收入及来源证明\n4. 近6个月在泰国或海外的常住居所证明\n\n入籍申请人批核时间预计为6至8周。" },
        { heading: "入籍申请人的30天加注规则", content: "入籍申请人须自会员ID签发之日起30天内完成签证加注。逾期须接受额外背景审查，该审查可再增加4至6周的处理时间。\n\n若您为入籍申请人，切勿延迟签证加注预约。会员资格获批后，请立即联系会员联络中心安排。" },
        { heading: "新护照签证加注", content: "若您在获批后或签证已发放后更换护照，旅行前须将签证转移至新护照。请提前备好新旧两本护照并联系会员联络中心。\n\n标准备料清单：\n1. 新护照\n2. 带有泰国精英签证贴纸的旧护照（如有）\n3. 护照资料页复印件\n4. 会员卡或确认函\n5. 若旧护照遗失或被盗，须提供报警证明\n6. 若个人资料变更，须提供改名或入籍证明文件\n\n具体办理方式视旧护照是否仍保留、签证是否已加注而定，务必在出行前向泰国特权卡支持部门核实。" },
        { heading: "会员推荐流程", content: "1. 确认您属于标准申请还是入籍申请\n2. 提交前备齐所有国籍及护照历史文件\n3. 新护照签发后立即通知泰国特权卡\n4. 文件审核通过后立即预约签证加注\n5. 在安排不可退改的旅行前完成加注\n6. 妥善保存护照、支持文件及批准邮件的电子副本\n\n如不确定所需文件，请联系我们的团队协助您在预约前审核资料。" },
      ] },
    },
  },

  // Downloads page
  downloads: {
    metaTitle: "下载申请表 | 泰国精英",
    metaDescription: "下载泰国精英所有会员套餐的说明书和申请表。",
    title: "下载中心",
    subtitle: "下载各会员套餐的申请表。",
    instructions: "提交申请：下载、填写并签署申请表，然后通过",
    portal: "申请门户",
    orEmail: "或发送邮件至",
    factSheet: "说明书",
    applicationForm: "申请表",
    privilegePoints: "特权积分",
    privilegePointsDesc: "每个会员计划都赋予您特权积分，可每年用于各种服务和活动。",
    privilegePointsSheet: "特权积分说明书",
  },
  testimonials: {
    badge: "全球会员信赖之选",
    title: "会员怎么说",
    reviews: "Google 评价",
    sourceNote: "来源：Google 商业档案 · 姓名已匿名处理",
  },
};
